// Generated professional Profile translations for all supported UI languages.
export const generatedProfileTranslations = {
  "de": {
    "subtitle": "Verwalten Sie Ihr Firmenprofil und Sicherheitsüberprüfung",
    "rejectedTitle": "Vorheriger Verifizierungsantrag wurde abgelehnt",
    "adminNote": "Hinweis des Admins:",
    "rejectedReason": "Es gab Unstimmigkeiten in den Angaben oder Bildern. Bitte machen Sie ein klares Foto mit der Live-Kamera und reichen Sie es erneut ein.",
    "pendingTitle": "Identitätsdokumente werden geprüft — Dashboard freigeschaltet",
    "pendingBody": "Ihre übermittelten Angaben und Bilder wurden erfolgreich empfangen und werden innerhalb von 24 Stunden im Admin-Panel mit den staatlichen Registern abgeglichen.",
    "pendingStrong": "Ihr Dashboard wurde bereits vollständig freigeschaltet, sodass Sie alle Funktionen nutzen können.",
    "pendingTail": "Der Admin behält sich das Recht vor, ein Konto zu sperren, falls Angaben als falsch oder ungenau festgestellt werden.",
    "unlockTitle": "Geben Sie die folgenden Informationen und Identitätsdokumente an, um Ihr Dashboard vollständig freizuschalten",
    "unlockBody": "Vervollständigen Sie die folgenden Angaben, NID oder Geburtsurkunde und ein Live-Porträt-Selfie, und klicken Sie dann auf \"Save Profile & Documents\", um alle Dashboard-Funktionen sofort freizuschalten. Der Admin wird Ihre Angaben innerhalb von 24 Stunden mit staatlichen Registern abgleichen und die endgültige Genehmigung erteilen.",
    "verifiedMerchant": "Verifizierter Händler",
    "underReview": "Verifizierung wird geprüft (Dashboard freigeschaltet)",
    "rejected": "Verifizierung abgelehnt (Handlung erforderlich)",
    "unverified": "Nicht verifiziertes Profil",
    "fullNamePlaceholder": "Geben Sie Ihren vollständigen Namen ein",
    "contactNumber": "Kontaktnummer",
    "chooseContact": "Wählen Sie eine Kontaktmethode:",
    "both": "Beides",
    "whatsappPlaceholder": "z. B. +1... / +44... / +880... (WhatsApp-Nummer mit Ländervorwahl)",
    "telegramPlaceholder": "z. B. +1... / +880... oder @Benutzername (Telegram-Nummer oder Benutzername)",
    "phonePlaceholder": "z. B. +1... / +44... / +880... (Nummer mit Ländervorwahl)",
    "contactNote": "Geben Sie eine aktive Nummer über die gewählte Methode für dringende Benachrichtigungen und Kommunikation an.",
    "identityVerification": "Identitätsprüfung",
    "birthCertificate": "Geburtsurkunde",
    "nidCard": "Nationaler Ausweis (NID-Karte)",
    "birthNumber": "Geburtsurkunden-Nummer (einzigartig)",
    "birthPlaceholder": "Geben Sie die Geburtsurkunden-Nummer ein",
    "nidNumber": "NID-Nummer (einzigartig)",
    "nidPlaceholder": "Geben Sie die NID-Nummer ein",
    "front": "Vorderseite",
    "back": "Rückseite",
    "liveSelfie": "Live-Porträt-Selfie (Passbildgröße)",
    "liveCameraOnly": "Nur Live-Kamera",
    "selfieInstruction": "Blicken Sie in die Kamera und machen Sie ein Live-Selfie bei guter Beleuchtung.",
    "noSelfie": "Kein Selfie",
    "retakeSelfie": "Live-Selfie erneut aufnehmen",
    "takeSelfie": "Machen Sie ein Selfie mit der vorderen Live-Kamera",
    "selfieWarning": "Zur Betrugsvermeidung muss das Gesichts-Selfie ausschließlich mit der Live-Kamera aufgenommen werden (Galerie-Upload deaktiviert).",
    "selfieTip": "Vermeiden Sie beim Fotografieren Brillen oder Masken und sorgen Sie für ausreichende Beleuchtung.",
    "saveUpdating": "Speichere und aktualisiere...",
    "updateLinks": "Informationen und Social-Links aktualisieren",
    "cameraSuccess": "Foto erfolgreich mit der Live-Kamera aufgenommen!",
    "errorPrefix": "Fehler:",
    "criticalWarning": "KRITISCHE WARNUNG & RICHTLINIEN",
    "rules": [
      "Bewerber ab 18 Jahren müssen sowohl NID als auch Geburtsurkunde vorlegen; eine Geburtsurkunde allein ist nicht ausreichend.",
      "Bewerber unter 18 Jahren müssen nur eine Geburtsurkunde und ein Live-Porträt-Selfie vorlegen.",
      "Die Geburtsurkunde muss ein Geburtsjahr von 2010 oder früher ausweisen.",
      "Das aus dem NID-Geburtsdatum berechnete Alter darf 40 Jahre nicht überschreiten; Konten über 40 Jahre werden nicht verifiziert.",
      "Übermittelte Angaben und Bescheinigungen werden mit verfügbaren staatlichen Online-Registern abgeglichen. Falsche Angaben, unklare oder veränderte Bilder oder Abweichungen werden nicht genehmigt.",
      "Pro NID oder Geburtsurkunde darf nur ein Konto genehmigt werden. Doppelte Konten sind verboten."
    ],
    "age18": "Über 18 (18+)",
    "under18": "Unter 18",
    "zoom": "Größer anzeigen",
    "notUploaded": "Noch kein Bild hochgeladen",
    "uploadGallery": "Aus Datei / Galerie hochladen",
    "uploadDevice": "Foto vom Gerät hochladen"
  },
  "ja": {
    "subtitle": "ビジネスプロフィールとセキュリティ確認を管理する",
    "rejectedTitle": "以前の認証申請は却下されました",
    "adminNote": "管理者メモ:",
    "rejectedReason": "情報または画像に不一致がありました。ライブカメラで鮮明な写真を撮影して再提出してください。",
    "pendingTitle": "身分証明書を審査中 — ダッシュボードは解除済み",
    "pendingBody": "送信された情報と画像は正常に受信され、管理パネルにより24時間以内に政府記録と照合されます。",
    "pendingStrong": "ダッシュボードはすでに完全に解除されているため、すべての機能を使用できます。",
    "pendingTail": "情報が虚偽または不正確であると判明した場合、管理者はアカウントをブロックする権利を留保します。",
    "unlockTitle": "ダッシュボードを完全に解除するには、以下の情報と身分証明書を提出してください",
    "unlockBody": "以下の情報、NIDまたは出生証明書、ライブ顔セルフィーを完了し、\"Save Profile & Documents\"をクリックしてすべてのダッシュボード機能を即座に解除してください。管理者は24時間以内に政府記録と照合して最終承認を行います。",
    "verifiedMerchant": "認証済み事業者",
    "underReview": "認証審査中（ダッシュボード解除済み）",
    "rejected": "認証拒否（対応が必要）",
    "unverified": "未認証プロフィール",
    "fullNamePlaceholder": "フルネームを入力してください",
    "contactNumber": "連絡先番号",
    "chooseContact": "連絡方法を選択:",
    "both": "両方",
    "whatsappPlaceholder": "例: +1... / +44... / +880... (国番号付きWhatsApp番号)",
    "telegramPlaceholder": "例: +1... / +880... または @username (Telegramの番号またはユーザー名)",
    "phonePlaceholder": "例: +1... / +44... / +880... (国番号付きの番号)",
    "contactNote": "緊急の通知や連絡のため、選択した方法で有効な番号を提供してください。",
    "identityVerification": "身分確認",
    "birthCertificate": "出生証明書",
    "nidCard": "国民ID（NIDカード）",
    "birthNumber": "出生証明書番号（固有）",
    "birthPlaceholder": "出生証明書番号を入力してください",
    "nidNumber": "NID番号（固有）",
    "nidPlaceholder": "NID番号を入力してください",
    "front": "表面",
    "back": "裏面",
    "liveSelfie": "ライブ顔セルフィー写真（パスポートサイズ）",
    "liveCameraOnly": "ライブカメラのみ",
    "selfieInstruction": "カメラに向かい、明るい照明でライブセルフィーを撮ってください。",
    "noSelfie": "セルフィーなし",
    "retakeSelfie": "ライブセルフィーを再撮影",
    "takeSelfie": "前面のライブカメラでセルフィーを撮る",
    "selfieWarning": "不正防止のため、顔のセルフィーはライブカメラでのみ撮影する必要があります（ギャラリーアップロードは無効）。",
    "selfieTip": "写真を撮る際は眼鏡やマスクを避け、十分な照明を確保してください。",
    "saveUpdating": "保存中および更新中...",
    "updateLinks": "情報とソーシャルリンクを更新する",
    "cameraSuccess": "ライブカメラで写真を正常に撮影しました！",
    "errorPrefix": "エラー:",
    "criticalWarning": "重大な警告とガイドライン",
    "rules": [
      "18歳以上の申請者はNIDと出生証明書の両方を提出する必要があります。出生証明書のみでは不十分です。",
      "18歳未満の申請者は出生証明書とライブ顔セルフィーのみを提出する必要があります。",
      "出生証明書は2010年以前の生年を示している必要があります。",
      "NIDの生年月日から算出される年齢は40歳以下でなければなりません。40歳を超えるアカウントは認証されません。",
      "提出された情報と証明書は、利用可能な政府のオンライン記録と照合されます。誤った情報、不明瞭または改変された画像、または不一致は承認されません。",
      "NIDまたは出生証明書につき承認されるアカウントは1つのみです。重複アカウントは禁止されています。"
    ],
    "age18": "18歳以上 (18+)",
    "under18": "18歳未満",
    "zoom": "拡大表示",
    "notUploaded": "まだ画像がアップロードされていません",
    "uploadGallery": "ファイル／ギャラリーからアップロード",
    "uploadDevice": "端末から写真をアップロード"
  },
  "ko": {
    "subtitle": "비즈니스 프로필 및 보안 인증 관리",
    "rejectedTitle": "이전 인증 신청이 거부되었습니다",
    "adminNote": "관리자 메모:",
    "rejectedReason": "정보 또는 이미지에 불일치가 있었습니다. 라이브 카메라로 선명한 사진을 찍어 다시 제출하세요.",
    "pendingTitle": "신분증 서류 검토 중 — 대시보드 잠금 해제됨",
    "pendingBody": "제출하신 정보와 이미지는 성공적으로 접수되었으며 관리 패널에서 24시간 이내에 정부 기록과 대조하여 확인합니다.",
    "pendingStrong": "대시보드는 이미 완전히 잠금 해제되어 모든 기능을 사용할 수 있습니다.",
    "pendingTail": "정보가 거짓이거나 부정확한 것으로 판명되면 관리자는 계정을 차단할 권리를 보유합니다.",
    "unlockTitle": "대시보드를 완전히 잠금 해제하려면 아래의 정보와 신분증을 제출하세요",
    "unlockBody": "아래 정보를 완성하고 NID 또는 출생증명서 및 라이브 얼굴 셀피를 제출한 후 \"Save Profile & Documents\"를 클릭하면 모든 대시보드 기능이 즉시 잠금 해제됩니다. 관리자는 24시간 이내에 정부 기록과 대조하여 최종 승인합니다.",
    "verifiedMerchant": "인증된 판매자",
    "underReview": "인증 검토 중 (대시보드 잠금 해제됨)",
    "rejected": "인증 거부 (조치 필요)",
    "unverified": "미인증 프로필",
    "fullNamePlaceholder": "전체 이름을 입력하세요",
    "contactNumber": "연락처 번호",
    "chooseContact": "연락 방법을 선택하세요:",
    "both": "둘 다",
    "whatsappPlaceholder": "예: +1... / +44... / +880... (국가 코드 포함 WhatsApp 번호)",
    "telegramPlaceholder": "예: +1... / +880... 또는 @username (Telegram 번호 또는 사용자명)",
    "phonePlaceholder": "예: +1... / +44... / +880... (국가 코드 포함 번호)",
    "contactNote": "긴급 알림 및 소통을 위해 선택한 방법으로 활성 번호를 제공하세요.",
    "identityVerification": "신원 확인",
    "birthCertificate": "출생 증명서",
    "nidCard": "국가 신분증 (NID 카드)",
    "birthNumber": "출생 증명서 번호 (고유)",
    "birthPlaceholder": "출생 증명서 번호를 입력하세요",
    "nidNumber": "NID 번호 (고유)",
    "nidPlaceholder": "NID 번호를 입력하세요",
    "front": "앞면",
    "back": "뒷면",
    "liveSelfie": "라이브 얼굴 셀피 사진 (여권 사이즈)",
    "liveCameraOnly": "라이브 카메라만",
    "selfieInstruction": "카메라를 바라보고 밝은 조명에서 라이브 셀피를 찍으세요.",
    "noSelfie": "셀피 없음",
    "retakeSelfie": "라이브 셀피 재촬영",
    "takeSelfie": "전면 라이브 카메라로 셀피 찍기",
    "selfieWarning": "사기 방지를 위해 얼굴 셀피는 라이브 카메라로만 촬영해야 합니다(갤러리 업로드 비활성화).",
    "selfieTip": "사진 촬영 시 안경이나 마스크를 피하고 충분한 조명을 확보하세요.",
    "saveUpdating": "저장 및 업데이트 중...",
    "updateLinks": "정보 및 소셜 링크 업데이트",
    "cameraSuccess": "라이브 카메라로 사진을 성공적으로 촬영했습니다!",
    "errorPrefix": "오류:",
    "criticalWarning": "중요 경고 및 지침",
    "rules": [
      "만 18세 이상 신청자는 NID와 출생 증명서를 모두 제출해야 합니다. 출생 증명서만으로는 충분하지 않습니다.",
      "18세 미만 신청자는 출생 증명서와 라이브 얼굴 셀피만 제출해야 합니다.",
      "출생 증명서에는 2010년 또는 이전의 출생연도가 표시되어야 합니다.",
      "NID의 생년월일로 계산된 나이는 40세를 초과해서는 안 됩니다. 40세 초과 계정은 인증되지 않습니다.",
      "제출된 정보와 증명서는 사용 가능한 정부 온라인 기록과 대조됩니다. 잘못된 정보, 흐릿하거나 변조된 이미지 또는 불일치는 승인되지 않습니다.",
      "NID 또는 출생 증명서당 승인되는 계정은 하나만 허용됩니다. 중복 계정은 금지됩니다."
    ],
    "age18": "18세 이상 (18+)",
    "under18": "18세 미만",
    "zoom": "확대해서 보기",
    "notUploaded": "아직 이미지가 업로드되지 않았습니다",
    "uploadGallery": "파일 / 갤러리에서 업로드",
    "uploadDevice": "기기에서 사진 업로드"
  },
  "ru": {
    "subtitle": "Управляйте профилем бизнеса и проверкой безопасности",
    "rejectedTitle": "Предыдущая заявка на верификацию была отклонена",
    "adminNote": "Заметка администратора:",
    "rejectedReason": "Обнаружено несоответствие в информации или изображениях. Пожалуйста, сделайте чёткое фото через живую камеру и отправьте заново.",
    "pendingTitle": "Документы удостоверяющие личность на проверке — панель управления разблокирована",
    "pendingBody": "Ваши отправленные данные и изображения успешно получены и будут проверены в админ-панели с государственными записями в течение 24 часов.",
    "pendingStrong": "Ваша панель управления уже полностью разблокирована, и вы можете пользоваться всеми функциями.",
    "pendingTail": "Админ оставляет за собой право заблокировать аккаунт, если будет обнаружено, что информация ложная или неточная.",
    "unlockTitle": "Предоставьте ниже информацию и документы личности, чтобы полностью разблокировать панель управления",
    "unlockBody": "Заполните приведённые ниже данные, NID или свидетельство о рождении и живое селфи лица, затем нажмите \"Save Profile & Documents\", чтобы немедленно разблокировать все функции панели. Админ проверит вашу информацию по государственным записям и даст окончательное одобрение в течение 24 часов.",
    "verifiedMerchant": "Проверенный продавец",
    "underReview": "Проверка на рассмотрении (панель разблокирована)",
    "rejected": "Проверка отклонена (требуется действие)",
    "unverified": "Непроверенный профиль",
    "fullNamePlaceholder": "Введите ваше полное имя",
    "contactNumber": "Контактный номер",
    "chooseContact": "Выберите способ связи:",
    "both": "Оба",
    "whatsappPlaceholder": "напр., +1... / +44... / +880... (номер WhatsApp с кодом страны)",
    "telegramPlaceholder": "напр., +1... / +880... или @username (номер или имя в Telegram)",
    "phonePlaceholder": "напр., +1... / +44... / +880... (номер с кодом страны)",
    "contactNote": "Укажите активный номер через выбранный способ для срочных уведомлений и связи.",
    "identityVerification": "Проверка личности",
    "birthCertificate": "Свидетельство о рождении",
    "nidCard": "Национальный ID (карта NID)",
    "birthNumber": "Номер свидетельства о рождении (уникальный)",
    "birthPlaceholder": "Введите номер свидетельства о рождении",
    "nidNumber": "Номер NID (уникальный)",
    "nidPlaceholder": "Введите номер NID",
    "front": "Лицевая сторона",
    "back": "Обратная сторона",
    "liveSelfie": "Живое селфи лица (паспортный размер)",
    "liveCameraOnly": "Только живая камера",
    "selfieInstruction": "Смотрите в камеру и сделайте живое селфи при хорошем освещении.",
    "noSelfie": "Нет селфи",
    "retakeSelfie": "Сделать живое селфи заново",
    "takeSelfie": "Сделать селфи с передней живой камеры",
    "selfieWarning": "Во избежание мошенничества селфи с лицом должно быть сделано только живой камерой (загрузка из галереи отключена).",
    "selfieTip": "При съёмке избегайте очков и маски, обеспечьте достаточное освещение.",
    "saveUpdating": "Сохранение и обновление...",
    "updateLinks": "Обновить информацию и ссылки в соцсетях",
    "cameraSuccess": "Фото успешно сделано живой камерой!",
    "errorPrefix": "Ошибка:",
    "criticalWarning": "КРИТИЧЕСКОЕ ПРЕДУПРЕЖДЕНИЕ И РУКОВОДСТВО",
    "rules": [
      "Заявители в возрасте 18 лет и старше должны предоставить и NID, и свидетельство о рождении; только свидетельство о рождении недостаточно.",
      "Заявители младше 18 лет должны предоставить только свидетельство о рождении и живое селфи лица.",
      "Свидетельство о рождении должно содержать год рождения 2010 или ранее.",
      "Возраст, вычисленный по дате рождения в NID, не должен превышать 40 лет; аккаунты старше 40 лет не будут верифицированы.",
      "Отправленные данные и свидетельства будут проверены по доступным государственным онлайн-записям. Неверная информация, неясные или изменённые изображения или несоответствия не будут одобрены.",
      "На каждый NID или свидетельство о рождении может быть одобрен только один аккаунт. Дублирующие аккаунты запрещены."
    ],
    "age18": "Старше 18 (18+)",
    "under18": "Младше 18",
    "zoom": "Просмотреть в большем размере",
    "notUploaded": "Изображение ещё не загружено",
    "uploadGallery": "Загрузить из файла / галереи",
    "uploadDevice": "Загрузить фото с устройства"
  },
  "tr": {
    "subtitle": "İş profilinizi ve güvenlik doğrulamanızı yönetin",
    "rejectedTitle": "Önceki doğrulama başvurusu reddedildi",
    "adminNote": "Yönetici notu:",
    "rejectedReason": "Bilgi veya resimlerde tutarsızlık vardı. Lütfen canlı kamerayla net bir fotoğraf çekip tekrar gönderin.",
    "pendingTitle": "Kimlik belgeleri inceleniyor — kontrol paneli açık",
    "pendingBody": "Gönderdiğiniz bilgiler ve görüntüler alındı; yönetici paneli tarafından 24 saat içinde devlet kayıtlarıyla doğrulanacaktır.",
    "pendingStrong": "Kontrol paneliniz zaten tamamen açıldı, tüm özellikleri kullanabilirsiniz.",
    "pendingTail": "Yönetici, herhangi bir bilginin yanlış veya hatalı olduğunun tespit edilmesi halinde hesabı engelleme hakkını saklı tutar.",
    "unlockTitle": "Kontrol panelinizi tamamen açmak için aşağıdaki bilgi ve kimlik belgelerini sağlayın",
    "unlockBody": "Aşağıdaki bilgileri, NID veya doğum belgesini ve canlı yüz selfisini tamamlayın, ardından tüm kontrol paneli özelliklerini hemen açmak için \"Save Profile & Documents\"e tıklayın. Yönetici bilgilerinizin devlet kayıtlarıyla doğruluğunu kontrol edecek ve 24 saat içinde son onayı verecektir.",
    "verifiedMerchant": "Doğrulanmış Satıcı",
    "underReview": "Doğrulama İncelemede (Kontrol Paneli Açık)",
    "rejected": "Doğrulama Reddedildi (İşlem Gerekli)",
    "unverified": "Doğrulanmamış Profil",
    "fullNamePlaceholder": "Tam adınızı girin",
    "contactNumber": "İletişim numarası",
    "chooseContact": "Bir iletişim yöntemi seçin:",
    "both": "Her ikisi",
    "whatsappPlaceholder": "örn. +1... / +44... / +880... (ülke kodlu WhatsApp numarası)",
    "telegramPlaceholder": "örn. +1... / +880... veya @kullanıcıadı (Telegram numarası veya kullanıcı adı)",
    "phonePlaceholder": "örn. +1... / +44... / +880... (ülke kodlu numara)",
    "contactNote": "Acil bildirimler ve iletişim için seçilen yöntemle aktif bir numara sağlayın.",
    "identityVerification": "Kimlik Doğrulama",
    "birthCertificate": "Doğum Belgesi",
    "nidCard": "Ulusal Kimlik (NID kartı)",
    "birthNumber": "Doğum Belgesi Numarası (Benzersiz)",
    "birthPlaceholder": "Doğum belgesi numarasını girin",
    "nidNumber": "NID Numarası (Benzersiz)",
    "nidPlaceholder": "NID numarasını girin",
    "front": "Ön",
    "back": "Arka",
    "liveSelfie": "Canlı Yüz Selfie Fotoğrafı (Pasaport Boyutu)",
    "liveCameraOnly": "Sadece Canlı Kamera",
    "selfieInstruction": "Kameraya bakın ve net ışıkta canlı bir selfie çekin.",
    "noSelfie": "Selfie yok",
    "retakeSelfie": "Canlı selfiyi yeniden çek",
    "takeSelfie": "Canlı ön kamerayla selfie çekin",
    "selfieWarning": "Dolandırıcılığı önlemek için yüz selfisi yalnızca canlı kamera ile çekilmelidir (galeri yükleme kapalı).",
    "selfieTip": "Fotoğraf çekerken gözlük veya maske takmaktan kaçının ve yeterli aydınlatma sağlayın.",
    "saveUpdating": "Kaydediliyor ve güncelleniyor...",
    "updateLinks": "Bilgileri ve sosyal bağlantıları güncelle",
    "cameraSuccess": "Fotoğraf canlı kamerayla başarıyla çekildi!",
    "errorPrefix": "Hata:",
    "criticalWarning": "KRİTİK UYARI & KILAVUZLAR",
    "rules": [
      "18 yaş ve üstü başvuru sahipleri hem NID hem de Doğum Belgesini sağlamalıdır; yalnızca Doğum Belgesi yeterli değildir.",
      "18 yaşından küçük başvuru sahipleri yalnızca Doğum Belgesini ve canlı yüz selfisini sağlamalıdır.",
      "Doğum belgesinde doğum yılı 2010 veya daha öncesi olmalıdır.",
      "NID doğum tarihinden hesaplanan yaş 40 yılı geçmemelidir; 40 üzeri hesaplar doğrulanmayacaktır.",
      "Gönderilen bilgiler ve belgeler mevcut devlet çevrimiçi kayıtlarıyla kontrol edilecektir. Yanlış bilgi, belirsiz veya değiştirilmiş görüntüler veya uyumsuzluklar onaylanmayacaktır.",
      "Her NID veya doğum belgesi için yalnızca bir hesap onaylanabilir. Çoğaltılmış hesaplar yasaktır."
    ],
    "age18": "18 ve üstü (18+)",
    "under18": "18 yaş altı",
    "zoom": "Büyüt",
    "notUploaded": "Henüz görsel yüklenmedi",
    "uploadGallery": "Dosyadan / galeriden yükle",
    "uploadDevice": "Cihazdan fotoğraf yükle"
  },
  "ta": {
    "subtitle": "உங்கள் வணிக پروஃபைல் மற்றும் பாதுகாப்பு சோதனைவை நிர்வகிக்கவும்",
    "rejectedTitle": "முந்தைய சரிபார்ப்பு விண்ணப்பம் நிராகரிக்கப்பட்டது",
    "adminNote": "அட்மின் குறிப்பு:",
    "rejectedReason": "தகவல் அல்லது படங்களில் பொருத்தமில்லாமை இருந்தது. தயவுசெய்து நேரடி கேமராவுடன் தெளிவான புகைப்படம் எடுத்து மீண்டும் சமர்பிக்கவும்.",
    "pendingTitle": "அடையாள ஆவணங்கள் பரிசீலனையில் — டாஷ்போர்டு திறக்கப்பட்டது",
    "pendingBody": "நீங்கள் சமர்பித்த தகவல்கள் மற்றும் படங்கள் வெற்றிகரமாக கிடைத்துள்ளன மற்றும் 24 மணி நேரத்திற்குள் நிர்வாக குழு மூலம் அரசு பதிவுகளுடன் சரிபார்க்கப்படும்.",
    "pendingStrong": "உங்கள் டாஷ்போர்டு ஏற்கனவே முழுமையாக திறக்கப்பட்டு அனைத்து அம்சங்களையும் பயன்படுத்தலாம்.",
    "pendingTail": "எந்த தகவலும் பொய் அல்லது தவறானதாக காணப்பட்டால் கணக்கை தடைசெய்ய நிர்வாகிக்கு உரிமை உண்டு.",
    "unlockTitle": "உங்கள் டாஷ்போர்டைப் பொதுவாகத் திறந்து கொள்ள கீழே உள்ள தகவலையும் அடையாள ஆவணங்களையும் வழங்கவும்",
    "unlockBody": "கீழுள்ள தகவல், NID அல்லது பிறப்பு சான்று, மற்றும் நேரடி முக selfie ஐப் பூர்த்தி செய்து, பிறகு அனைத்து டாஷ்போர்டு அம்சங்களையும் உடனே திறக்க \"Save Profile & Documents\" ஐ அழுத்தவும். நிர்வாகி உங்கள் தகவல்களை அரசு பதிவுகளுடன் சரிபார்த்து 24 மணி நேரத்தில் இறுதி அனுமதி வழங்குவார்.",
    "verifiedMerchant": "சரிபார்க்கப்பட்ட வர்த்தகர்",
    "underReview": "சரிபார்ப்பு பரிசீலனையில் (டாஷ்போர்டு திறந்தது)",
    "rejected": "சரிபார்ப்பு நிராகரிக்கப்பட்டது (செயல் தேவை)",
    "unverified": "சரிபார்க்கப்படாத சுயவிவரம்",
    "fullNamePlaceholder": "உங்கள் முழு பெயரை உள்ளிடவும்",
    "contactNumber": "தொடர்பு எண்",
    "chooseContact": "தொடர்பு முறையைத் தேர்ந்தெடுக்கவும்:",
    "both": "இரண்டும்",
    "whatsappPlaceholder": "உதா. +1... / +44... / +880... (நாட்டு குறியீட்டுடன் WhatsApp நம்பர்)",
    "telegramPlaceholder": "உதா. +1... / +880... அல்லது @username (Telegram எண் அல்லது பயனர்பெயர்)",
    "phonePlaceholder": "உதா. +1... / +44... / +880... (நாட்டு குறியீட்டுடன் எண்)",
    "contactNote": "அவசர அறிவிப்புகள் மற்றும் தொடர்புக்காக தேர்ந்தெடுக்கப்பட்ட முறைக்காக செயல்பாட்டில் இருக்கும் எண்ணை வழங்கவும்.",
    "identityVerification": "அடையாளச் சோதனை",
    "birthCertificate": "பிறப்பு சான்றிதழ்",
    "nidCard": "தேசிய அடையாளம் (NID அட்டை)",
    "birthNumber": "பிறப்பு சான்றிதழ் எண் (தனித்துவமானது)",
    "birthPlaceholder": "பிறப்பு சான்றிதழ் எண் உள்ளிடவும்",
    "nidNumber": "NID எண் (தனித்துவமானது)",
    "nidPlaceholder": "NID எண்ணை உள்ளிடவும்",
    "front": "முன்",
    "back": "பின்",
    "liveSelfie": "நேரடி முக selfie புகைப்படம் (பாஸ்போர்ட் அளவு)",
    "liveCameraOnly": "நேரடி கேமரா மட்டுமே",
    "selfieInstruction": "கேமராவை எதிர்கொண்டு தெளிவான வெளிச்சத்தில் நேரடி selfie எடுக்கவும்.",
    "noSelfie": "Selfie இல்லை",
    "retakeSelfie": "நேரடி selfietஐ மீண்டும் எடு",
    "takeSelfie": "நேரடி முன்னணி கேமராவுடன் selfie எடுக்கவும்",
    "selfieWarning": "வஞ்சகத்தைத் தடுக்கும் நோக்கில், முக selfie yalnızca நேரடி கேமராவால் மட்டும் எடுக்கப்பட வேண்டும் (கேலரி ஏற்றம் முடக்கப்பட்டிருக்கிறது).",
    "selfieTip": "புகைப்படம் எடுத்தபோது கண்ணாபட்டி அல்லது முகக்கவசம் அணியாமல் இருக்கவும் மற்றும் போதுமான விளக்கத்தை உறுதிசெய்யவும்.",
    "saveUpdating": "சேமிக்கப்பட்டுப் புதுப்பிக்கப்படுகிறது...",
    "updateLinks": "தகவல்களையும் சமூக இணைப்புகளையும் புதுப்பிக்கவும்",
    "cameraSuccess": "நேரடி கேமராவுடன் புகைப்படம் வெற்றிகரமாகப் பிடிக்கப்பட்டது!",
    "errorPrefix": "பிழை:",
    "criticalWarning": "முக்கிய எச்சரிக்கை மற்றும் வழிகாட்டுதல்கள்",
    "rules": [
      "18 வயதிற்கும் மேற்பட்ட விண்ணப்பதாரர்கள் NID மற்றும் பிறப்பு சான்றிதழை இரண்டும் வழங்க வேண்டும்; ஒரு பிறப்பு சான்றிதழ் மட்டும் போதுமானது அல்ல.",
      "18 வயதிற்கும் குறைவான விண்ணப்பதாரர்கள் yalnızca பிறப்பு சான்றிதழ் மற்றும் நேரடி முக selfie அளிக்க வேண்டும்.",
      "பிறப்பு சான்றிதழில் 2010 அல்லது அதற்கு முன் பிறந்த ஆண்டு காட்டப்பட வேண்டும்.",
      "NID பிறந்த தேதியில் இருந்து கணக்கிடப்படும் வயது 40 ஆண்டுகளை தாண்டக் கூடாது; 40க்கும் மேற்பட்ட கணக்குகள் doğrulanmayacaktır.",
      "சமர்ப்பிக்கப்பட்ட தகவல்கள் மற்றும் சான்றிதழ்கள் அரசு ஆன்லைன் பதிவுகளுக்கு எதிராக சரிபார்க்கப்படும். தவறான தகவல், தெளிவற்ற அல்லது மாற்றப்பட்ட படங்கள், அல்லது பொருத்தமற்றவை அனுமதிப்படமாட்ட.",
      "ஒவ்வொரு NID அல்லது பிறப்பு சான்றிதழிற்கும் yalnızca ஒரு கணக்கு ஒப்புதலடையலாம். நகல் கணக்குகள் தடைசெய்யப்படுகின்றன."
    ],
    "age18": "18 மேல் (18+)",
    "under18": "18 க்கும் குறைவானவர்",
    "zoom": "பெரிதாகக் காண்க",
    "notUploaded": "இன்னும் படம் பதிவேற்றம் செய்யப்படவில்லை",
    "uploadGallery": "கோப்பு / கேலரியிலிருந்து பதிவேற்றவும்",
    "uploadDevice": " சாதனத்திலிருந்து புகைப்படம் பதிவேற்று"
  },
  "te": {
    "subtitle": "మీ వ్యాపార ప్రొఫైల్ మరియు భద్రతా ధృవీకరణను నిర్వహించండి",
    "rejectedTitle": "మునుపటి ధృవీకరణ దరఖాస్తు తిరస్కరించబడింది",
    "adminNote": "అడ్మిన్ గమనిక:",
    "rejectedReason": "సమాచారం లేదా చిత్రాలలో విభిన్నత జరిగింది. దయచేసి లైవ్ కెమెరాతో స్పష్టమైన ఫోటో తీసుకుని మళ్లీ సమర్పించండి.",
    "pendingTitle": "ఐడెంటిటీ పత్రాలు సమీక్షలో ఉన్నాయి — డాష్‌బోర్డ్ అన్లాక్ చేయబడింది",
    "pendingBody": "మీరు సమర్పించిన సమాచారం మరియు చిత్రాలు సఫలంగా స్వీకరించబడ్డాయి మరియు 24 గంటలలో అడ్మిన్ ప్యానల్ ద్వారా ప్రభుత్వ రికార్డుల పాలనలో ధృవీకరించబడును.",
    "pendingStrong": "మీ డాష్‌బోర్డ్ ఇప్పటికే పూర్తిగా అన్లాక్ చేయబడింది కాబట్టి మీరు అన్ని ఫీచర్లను ఉపయోగించుకోవచ్చు.",
    "pendingTail": "ఏ సమాచారమూ తప్పుడు లేదా తప్పుగా కనపడితే ఖాతాను బ్లాక్ చేయడంపై అడ్మిన్ హక్కు రిజర్వ్ చేసుకుంటాడు.",
    "unlockTitle": "మీ డాష్‌బోర్డ్ని పూర్తిగా అన్లాక్ చేయడానికి క్రింద ఇచ్చిన సమాచారాన్ని మరియు గుర్తింపు పత్రాలను అందించండి",
    "unlockBody": "క్రింద సూచించిన సమాచారాన్ని, NID లేదా జనన సర్టిఫికేట్, మరియు లైవ్ ఫేస్ సెల్ఫీ ని పూర్తి చేసి, మొత్తం డాష్‌బోర్డ్ ఫీచర్లను తక్షణం అన్లాక్ చేయడానికి \"Save Profile & Documents\" ను క్లిక్ చేయండి. అడ్మిన్ మీ సమాచారాన్ని ప్రభుత్వ రికార్డులతో సరిపోల్చి 24 గంటలలో తుది ఆమోదం ఇస్తారు.",
    "verifiedMerchant": "ధృవీకరించబడిన వ్యాపారి",
    "underReview": "ధృవీకరణ సమీక్షలో ఉంది (డాష్‌బోర్డ్ అన్లాక్)",
    "rejected": "ధృవీకరణ తిరస్కరించబడింది (చర్య అవసరం)",
    "unverified": "ధృవీకరించని ప్రొఫైల్",
    "fullNamePlaceholder": "మీ పూర్తి పేరు నమోదు చేయండి",
    "contactNumber": "సంప్రదింపు నంబర్",
    "chooseContact": "సంప్రదింపు విధానాన్ని ఎంచుకోండి:",
    "both": "రెండు",
    "whatsappPlaceholder": "ఉదా. +1... / +44... / +880... (దేశ కోడ్ ఉన్న WhatsApp నంబర్)",
    "telegramPlaceholder": "ఉదా. +1... / +880... లేదా @username (Telegram నంబర్ లేదా username)",
    "phonePlaceholder": "ఉదా. +1... / +44... / +880... (దేశ కోడ్ తో నంబర్)",
    "contactNote": "తక్షణ సమాచారం మరియు సంభాషణ కోసం నిర్ణయించిన విధానంతో ఒక చురుకైన నంబర్ ఇవ్వండి.",
    "identityVerification": "ఐడెంటిటీ ధృవీకరణ",
    "birthCertificate": "జనన సర్టిఫికేట్",
    "nidCard": "నేషనల్ ఐడెంటిటీ (NID కార్డు)",
    "birthNumber": "జనన సర్టిఫికెట్ నంబర్ (అనన్యమైనది)",
    "birthPlaceholder": "జనన సర్టిఫికెట్ నంబర్ నమోదు చేయండి",
    "nidNumber": "NID నంబర్ (అనన్యమైనది)",
    "nidPlaceholder": "NID నంబర్ నమోదు చేయండి",
    "front": "ముందు",
    "back": "వెనుక",
    "liveSelfie": "లైవ్ ఫేస్ సెల్ఫీ ఫోటో (పాస్‌పోర్ట్ పరిమాణం)",
    "liveCameraOnly": "లైవ్ కెమెరా మాత్రమే",
    "selfieInstruction": "కెమెరాకి ముఖం చూపించి స్పష్టమైన లైటింగ్లో లైవ్ సెల్ఫీ తీసుకోండి.",
    "noSelfie": "సెల్ఫీ లేదు",
    "retakeSelfie": "లైవ్ సెల్ఫీని మళ్ళీ తీసుకోండి",
    "takeSelfie": "లైవ్ ఫ్రంట్ కెమెరాతో సెల్ఫీ తీసుకోండి",
    "selfieWarning": "బోగస్ నివారించడానికి, ఫేస్ సెల్ఫీని తప్పక లైవ్ కెమెరాతోనే తీసుకోవాలి (గ్యాలరీ అప్‌లోడ్ నిలిపివేయబడింది).",
    "selfieTip": "ఫోటో తీస్తుండగా చెదురు కన్నుకూల వస్త్రాలు లేదా ముఖావరణాన్ని పెట్టకూడదు మరియు సరైన లైటింగ్ ఉంచండి.",
    "saveUpdating": "సేవ్ చేయబడుతోంది మరియు నవీకరిస్తోంది...",
    "updateLinks": "సమాచారం మరియు సామాజిక లింకులను నవీకరించండి",
    "cameraSuccess": "లైవ్ కెమెరా తో ఫోటో విజయవంతంగా తీసుకోబడింది!",
    "errorPrefix": "లోపం:",
    "criticalWarning": "సున్నిత హెచ్చరిక & మార్గదర్శకాలు",
    "rules": [
      "18 ఏండ్లను దాటిన అభ్యర్థులు NID మరియు జనన సర్టిఫికెట్ రెండింటినీ అందించాలి; ఒక జనన సర్టిఫికెట్ మాత్రమే సరిపోదు.",
      "18 ఏండ్లకు తక్కువ వయసున్న అభ్యర్థులు yalnızca జనన సర్టిఫికెట్ మరియు లైవ్ ఫేస్ సెల్ఫీ మాత్రమే అందించాలి.",
      "జనన సర్టిఫికేట్‌లో 2010 లేదా అంతకన్నా ముందరి జననం సంవత్సరం చూపించాలి.",
      "NID జనన తేదీ నుంచి గణించబడే వయస్సు 40 సంవత్సరాలను మించకూడదు; 40 మించి ఉన్న ఖాతాలు ధృవీకరించబడవు.",
      "సమర్పించిన సమాచారం మరియు సర్టిఫికెట్లు అందుబాటులో ఉన్న ప్రభుత్వ ఆన్‌లైన్ రికార్డులతో తాడిచేయబడ్డతాయి. తప్పు సమాచారం, अस्पष्ट లేదా మార్చబడిన చిత్రాలు లేదా సరిపోకపోవడం ఆమోదించబడదు.",
      "ఒకే NID లేదా జనన సర్టిఫికేట్ కు ఒక్కటే ఖాతా ఆమోదించబడుతుంది. నకిలీ ఖాతాలు నిషేధించబడ్డాయి."
    ],
    "age18": "18 పైగా (18+)",
    "under18": "18 కన్నా తక్కువ",
    "zoom": "పెద్దదిగా చూడండి",
    "notUploaded": "ఇంకా చిత్రం అప్లోడ్ చేయబడలేదు",
    "uploadGallery": "ఫైల్/గ్యాలరీ నుండి అప్‌లోడ్ చేయండి",
    "uploadDevice": "సరికొత్త పరికరంనుంచి ఫోటో అప్‌లోడ్ చేయండి"
  },
  "ur": {
    "subtitle": "اپنا کاروباری پروفائل اور سیکیورٹی ویریفیکیشن منظم کریں",
    "rejectedTitle": "پچھلا تصدیقی درخواست مسترد کر دیا گیا",
    "adminNote": "ایڈمن نوٹ:",
    "rejectedReason": "معلومات یا تصاویر میں تضاد تھا۔ براہِ کرم لائیو کیمرہ سے واضح تصویر لیں اور دوبارہ جمع کریں۔",
    "pendingTitle": "شناختی دستاویزات زیرِ جائزہ — ڈیش بورڈ کھول دیا گیا",
    "pendingBody": "آپ کی جمع کردہ معلومات اور تصاویر کامیابی سے موصول ہو چکی ہیں اور ایڈمن پینل کے ذریعے 24 گھنٹوں کے اندر سرکاری ریکارڈز سے ملائی جائیں گی۔",
    "pendingStrong": "آپ کا ڈیش بورڈ پہلے ہی مکمل طور پر کھل چکا ہے تاکہ آپ تمام خصوصیات استعمال کر سکیں۔",
    "pendingTail": "اگر کوئی معلومات غلط یا غیر درست پائی جاتی ہیں تو اکاؤنٹ کو بلاک کرنے کا حق ایڈمن کے پاس مخصوص ہے۔",
    "unlockTitle": "اپنا ڈیش بورڈ مکمل طور پر کھولنے کے لیے نیچے دی گئی معلومات اور شناختی دستاویزات فراہم کریں",
    "unlockBody": "نیچے دی گئی معلومات، NID یا برتھ سرٹیفکیٹ، اور لائیو فیس سیلفی مکمل کریں، پھر تمام ڈیش بورڈ خصوصیات فوری طور پر ان لاک کرنے کے لیے \"Save Profile & Documents\" پر کلک کریں۔ ایڈمن آپ کی معلومات کو سرکاری ریکارڈ سے ملائے گا اور 24 گھنٹوں میں حتمی منظوری دے گا۔",
    "verifiedMerchant": "تصدیق شدہ مرچنٹ",
    "underReview": "تصدیق زیرِ جائزہ (ڈیش بورڈ کھلا)",
    "rejected": "تصدیق مسترد (عمل درکار)",
    "unverified": "نان تصدیق شدہ پروفائل",
    "fullNamePlaceholder": "اپنا پورا نام درج کریں",
    "contactNumber": "رابطہ نمبر",
    "chooseContact": "رابطے کا طریقہ منتخب کریں:",
    "both": "دونوں",
    "whatsappPlaceholder": "مثلاً +1... / +44... / +880... (کنٹری کوڈ کے ساتھ WhatsApp نمبر)",
    "telegramPlaceholder": "مثلاً +1... / +880... یا @username (Telegram نمبر یا یوزر نیم)",
    "phonePlaceholder": "مثلاً +1... / +44... / +880... (کنٹری کوڈ کے ساتھ نمبر)",
    "contactNote": "فوری اطلاعات اور مواصلات کے لیے منتخب شدہ طریقے کے ذریعے ایک فعال نمبر فراہم کریں۔",
    "identityVerification": "شناخت کی تصدیق",
    "birthCertificate": "برتھ سرٹیفیکیٹ",
    "nidCard": "قومی شناخت (NID کارڈ)",
    "birthNumber": "برتھ سرٹیفیکیٹ نمبر (منفرد)",
    "birthPlaceholder": "برتھ سرٹیفیکیٹ نمبر درج کریں",
    "nidNumber": "NID نمبر (منفرد)",
    "nidPlaceholder": "NID نمبر درج کریں",
    "front": "سامنے",
    "back": "پیچھے",
    "liveSelfie": "لائیو فیس سیلفی تصویر (پاسپورٹ سائز)",
    "liveCameraOnly": "صرف لائیو کیمرہ",
    "selfieInstruction": "کیمرے کی طرف دیکھیں اور صاف روشنی میں لائیو سیلفی لیں۔",
    "noSelfie": "کوئی سیلفی نہیں",
    "retakeSelfie": "لائیو سیلفی دوبارہ لیں",
    "takeSelfie": "لائیو فرنٹ کیمرے سے سیلفی لیں",
    "selfieWarning": "دہشت گردی سے بچنے کے لیے، چہرے کی سیلفی صرف لائیو کیمرہ سے ہی لی جانی چاہیے (گیلری اپ لوڈ غیر فعال).",
    "selfieTip": "تصویر لیتے وقت چشمہ یا ماسک پہننے سے گریز کریں اور مناسب روشنی یقینی بنائیں۔",
    "saveUpdating": "محفوظ کیا جا رہا ہے اور اپ ڈیٹ ہو رہا ہے...",
    "updateLinks": "معلومات اور سوشل لنکس اپ ڈیٹ کریں",
    "cameraSuccess": "تصویر لائیو کیمرہ کے ساتھ کامیابی سے لی گئی!",
    "errorPrefix": "خرابی:",
    "criticalWarning": "اہم انتباہ اور ہدایات",
    "rules": [
      "18 سال یا اس سے زائد امیدواروں کو دونوں NID اور برتھ سرٹیفیکیٹ فراہم کرنا لازمی ہے؛ صرف برتھ سرٹیفیکیٹ کافی نہیں ہوگا۔",
      "18 سال سے کم امیدواروں کو صرف برتھ سرٹیفیکیٹ اور لائیو فیس سیلفی فراہم کرنا ہوگا۔",
      "برتھ سرٹیفیکیٹ میں پیدائش کا سال 2010 یا اس سے قبل ہونا چاہیے۔",
      "NID کی تاریخ پیدائش سے حساب کیا گیا عمر 40 سال سے زیادہ نہیں ہونا چاہیے؛ 40 سے زائد اکاؤنٹس کی توثیق نہیں کی جائے گی۔",
      "جمع کردہ معلومات اور سرٹیفیکیٹس دستیاب سرکاری آن لائن ریکارڈز کے خلاف چیک کیے جائیں گے۔ غلط معلومات، غیر واضح یا تبدیل شدہ تصاویر، یا میل نہ کھانے والے دستاویزات کی منظوری نہیں دی جائے گی۔",
      "ہر NID یا برتھ سرٹیفیکیٹ کے لیے صرف ایک اکاؤنٹ منظور کیا جا سکتا ہے۔ نقل اکاؤنٹس ممنوع ہیں۔"
    ],
    "age18": "18 سے اوپر (18+)",
    "under18": "18 سال سے کم",
    "zoom": "بڑا دیکھیں",
    "notUploaded": "ابھی تک تصویر اپ لوڈ نہیں ہوئی",
    "uploadGallery": "فائل/گیلری سے اپ لوڈ کریں",
    "uploadDevice": "ڈیوائس سے تصویر اپ لوڈ کریں"
  },
  "it": {
    "subtitle": "Gestisci il profilo aziendale e la verifica di sicurezza",
    "rejectedTitle": "La precedente richiesta di verifica è stata rifiutata",
    "adminNote": "Nota dell'amministratore:",
    "rejectedReason": "C'è stata un'incongruenza nelle informazioni o nelle immagini. Scatta una foto chiara con la fotocamera live e invia di nuovo.",
    "pendingTitle": "I documenti d'identità sono in revisione — cruscotto sbloccato",
    "pendingBody": "Le informazioni e le immagini inviate sono state ricevute con successo e saranno verificate con i registri governativi dall'admin entro 24 ore.",
    "pendingStrong": "Il tuo cruscotto è già completamente sbloccato e puoi usare tutte le funzionalità.",
    "pendingTail": "L'admin si riserva il diritto di bloccare un account se qualsiasi informazione risulta falsa o inaccurata.",
    "unlockTitle": "Fornisci le informazioni e i documenti d'identità qui sotto per sbloccare completamente il cruscotto",
    "unlockBody": "Completa le informazioni qui sotto, NID o certificato di nascita, e un selfie live del volto, poi clicca \"Save Profile & Documents\" per sbloccare tutte le funzionalità del cruscotto immediatamente. L'admin verificherà le tue informazioni con i registri governativi e fornirà l'approvazione finale entro 24 ore.",
    "verifiedMerchant": "Commerciante verificato",
    "underReview": "Verifica in corso (Cruscotto sbloccato)",
    "rejected": "Verifica rifiutata (Azione richiesta)",
    "unverified": "Profilo non verificato",
    "fullNamePlaceholder": "Inserisci il tuo nome completo",
    "contactNumber": "Numero di contatto",
    "chooseContact": "Seleziona un metodo di contatto:",
    "both": "Entrambi",
    "whatsappPlaceholder": "es. +1... / +44... / +880... (numero WhatsApp con prefisso)",
    "telegramPlaceholder": "es. +1... / +880... o @username (numero o username Telegram)",
    "phonePlaceholder": "es. +1... / +44... / +880... (numero con prefisso)",
    "contactNote": "Fornisci un numero attivo attraverso il metodo selezionato per notifiche e comunicazioni urgenti.",
    "identityVerification": "Verifica dell'identità",
    "birthCertificate": "Certificato di nascita",
    "nidCard": "Carta d'identità nazionale (NID)",
    "birthNumber": "Numero del certificato di nascita (Unico)",
    "birthPlaceholder": "Inserisci il numero del certificato di nascita",
    "nidNumber": "Numero NID (Unico)",
    "nidPlaceholder": "Inserisci il numero NID",
    "front": "Fronte",
    "back": "Retro",
    "liveSelfie": "Selfie live del volto (Formato passaporto)",
    "liveCameraOnly": "Solo fotocamera live",
    "selfieInstruction": "Guardare la fotocamera e scattare un selfie live con luce chiara.",
    "noSelfie": "Nessun selfie",
    "retakeSelfie": "Riscatta selfie live",
    "takeSelfie": "Scatta un selfie con la fotocamera frontale live",
    "selfieWarning": "Per prevenire frodi, il selfie deve essere scattato solo con la fotocamera live (upload da galleria disabilitato).",
    "selfieTip": "Evita occhiali o maschere durante lo scatto e assicurati di avere luce sufficiente.",
    "saveUpdating": "Salvataggio e aggiornamento...",
    "updateLinks": "Aggiorna informazioni e link social",
    "cameraSuccess": "Foto catturata con successo con la fotocamera live!",
    "errorPrefix": "Errore:",
    "criticalWarning": "AVVISO CRITICO E LINEE GUIDA",
    "rules": [
      "I richiedenti di età pari o superiore a 18 anni devono fornire sia NID che certificato di nascita; solo il certificato di nascita non è sufficiente.",
      "I richiedenti sotto i 18 anni devono fornire solo il certificato di nascita e un selfie live del volto.",
      "Il certificato di nascita deve mostrare un anno di nascita pari o precedente al 2010.",
      "L'età calcolata dalla data di nascita sul NID non deve essere superiore a 40 anni; gli account oltre i 40 anni non saranno verificati.",
      "Le informazioni e i certificati inviati saranno controllati con i registri governativi online disponibili. Informazioni errate, immagini poco chiare o alterate, o discrepanze non saranno approvate.",
      "Solo un account può essere approvato per NID o certificato di nascita. Account duplicati sono proibiti."
    ],
    "age18": "Oltre 18 (18+)",
    "under18": "Sotto 18",
    "zoom": "Visualizza ingrandito",
    "notUploaded": "Nessuna immagine caricata",
    "uploadGallery": "Carica da file / galleria",
    "uploadDevice": "Carica foto dal dispositivo"
  },
  "nl": {
    "subtitle": "Beheer uw bedrijfsprofiel en beveiligingsverificatie",
    "rejectedTitle": "Eerdere verificatieaanvraag is afgewezen",
    "adminNote": "Opmerking van admin:",
    "rejectedReason": "Er was een inconsistentie in de informatie of afbeeldingen. Maak een duidelijke foto met de live-camera en dien opnieuw in.",
    "pendingTitle": "Identiteitsdocumenten worden beoordeeld — dashboard ontgrendeld",
    "pendingBody": "Uw ingediende informatie en afbeeldingen zijn succesvol ontvangen en worden binnen 24 uur door het adminpaneel geverifieerd aan de hand van overheidsgegevens.",
    "pendingStrong": "Uw dashboard is al volledig ontgrendeld zodat u alle functies kunt gebruiken.",
    "pendingTail": "De admin behoudt zich het recht voor een account te blokkeren als informatie onjuist of onwaar blijkt te zijn.",
    "unlockTitle": "Geef onderstaande informatie en identiteitsdocumenten op om uw dashboard volledig te ontgrendelen",
    "unlockBody": "Vul hieronder de informatie in, NID of geboorteakte, en een live selfie van het gezicht, en klik daarna op \"Save Profile & Documents\" om direct alle dashboardfuncties te ontgrendelen. De admin zal uw gegevens verifiëren met overheidsgegevens en binnen 24 uur definitieve goedkeuring geven.",
    "verifiedMerchant": "Geverifieerde handelaar",
    "underReview": "Verificatie in beoordeling (Dashboard ontgrendeld)",
    "rejected": "Verificatie afgewezen (Actie vereist)",
    "unverified": "Niet-geverifiëerd profiel",
    "fullNamePlaceholder": "Voer uw volledige naam in",
    "contactNumber": "Contactnummer",
    "chooseContact": "Selecteer een contactmethode:",
    "both": "Beide",
    "whatsappPlaceholder": "bijv. +1... / +44... / +880... (WhatsApp-nummer met landcode)",
    "telegramPlaceholder": "bijv. +1... / +880... of @gebruikersnaam (Telegram-nummer of gebruikersnaam)",
    "phonePlaceholder": "bijv. +1... / +44... / +880... (nummer met landcode)",
    "contactNote": "Geef een actief nummer via de geselecteerde methode voor urgente meldingen en communicatie.",
    "identityVerification": "Identiteitsverificatie",
    "birthCertificate": "Geboorteakte",
    "nidCard": "National ID (NID-kaart)",
    "birthNumber": "Geboorteakte nummer (Uniek)",
    "birthPlaceholder": "Voer het nummer van de geboorteakte in",
    "nidNumber": "NID-nummer (Uniek)",
    "nidPlaceholder": "Voer het NID-nummer in",
    "front": "Voorzijde",
    "back": "Achterzijde",
    "liveSelfie": "Live gezichtsselfie foto (Paspoortformaat)",
    "liveCameraOnly": "Alleen live-camera",
    "selfieInstruction": "Kijk naar de camera en maak een live selfie bij goede verlichting.",
    "noSelfie": "Geen selfie",
    "retakeSelfie": "Maak live selfie opnieuw",
    "takeSelfie": "Maak een selfie met de live frontcamera",
    "selfieWarning": "Om fraude te voorkomen moet de gezichtsselfie alleen met de live-camera worden gemaakt (galerijupload uitgeschakeld).",
    "selfieTip": "Vermijd het dragen van een bril of masker tijdens de foto en zorg voor voldoende licht.",
    "saveUpdating": "Bezig met opslaan en bijwerken...",
    "updateLinks": "Werk informatie en sociale links bij",
    "cameraSuccess": "Foto succesvol vastgelegd met de live-camera!",
    "errorPrefix": "Fout:",
    "criticalWarning": "CRITISCHE WAARSCHUWING & RICHTLIJNEN",
    "rules": [
      "Aanvragers van 18 jaar of ouder moeten zowel NID als geboorteakte overleggen; alleen een geboorteakte is niet voldoende.",
      "Aanvragers onder de 18 moeten alleen een geboorteakte en een live gezichtsselfie overleggen.",
      "De geboorteakte moet een geboortejaar van 2010 of eerder tonen.",
      "De leeftijd berekend op basis van de geboortedatum op het NID mag niet meer dan 40 jaar zijn; accounts boven 40 worden niet geverifieerd.",
      "Ingezonden informatie en certificaten worden gecontroleerd aan beschikbare online overheidsregisters. Onjuiste informatie, onduidelijke of gewijzigde afbeeldingen, of mismatch worden niet goedgekeurd.",
      "Slechts één account mag worden goedgekeurd per NID of geboorteakte. Dubbele accounts zijn verboden."
    ],
    "age18": "Ouder dan 18 (18+)",
    "under18": "Onder 18",
    "zoom": "Groter bekijken",
    "notUploaded": "Nog geen afbeelding geüpload",
    "uploadGallery": "Uploaden vanaf bestand / galerij",
    "uploadDevice": "Foto uploaden vanaf apparaat"
  },
  "th": {
    "subtitle": "จัดการโปรไฟล์ธุรกิจและการยืนยันความปลอดภัย",
    "rejectedTitle": "คำขอการยืนยันก่อนหน้านี้ถูกปฏิเสธ",
    "adminNote": "หมายเหตุผู้ดูแล:",
    "rejectedReason": "มีความไม่สอดคล้องในข้อมูลหรือภาพ กรุณาถ่ายรูปชัดเจนด้วยกล้องสดและส่งใหม่",
    "pendingTitle": "เอกสารยืนยันตัวตนกำลังอยู่ระหว่างการตรวจสอบ — แดชบอร์ดถูกปลดล็อก",
    "pendingBody": "ข้อมูลและภาพที่คุณส่งได้รับเรียบร้อยแล้ว และจะถูกตรวจสอบกับฐานข้อมูลรัฐบาลโดยแผงผู้ดูแลภายใน 24 ชั่วโมง",
    "pendingStrong": "แดชบอร์ดของคุณถูกปลดล็อกครบถ้วนแล้ว คุณสามารถใช้ฟีเจอร์ทั้งหมดได้",
    "pendingTail": "ผู้ดูแลมีสิทธิ์บล็อกบัญชีหากพบว่าข้อมูลใดเป็นเท็จหรือไม่ถูกต้อง",
    "unlockTitle": "ระบุข้อมูลและเอกสารยืนยันตัวตนด้านล่างเพื่อปลดล็อกแดชบอร์ดทั้งหมด",
    "unlockBody": "กรอกข้อมูลด้านล่าง, NID หรือสูติบัตร, และถ่ายเซลฟี่สดรูปหน้า แล้วคลิก \"Save Profile & Documents\" เพื่อปลดล็อกฟีเจอร์ทั้งหมดของแดชบอร์ดทันที ผู้ดูแลจะตรวจสอบข้อมูลกับฐานข้อมูลรัฐบาลและให้การอนุมัติภายใน 24 ชั่วโมง",
    "verifiedMerchant": "ผู้ประกอบการที่ได้รับการยืนยัน",
    "underReview": "กำลังตรวจสอบการยืนยัน (แดชบอร์ดถูกปลดล็อก)",
    "rejected": "การยืนยันถูกปฏิเสธ (ต้องดำเนินการ)",
    "unverified": "โปรไฟล์ยังไม่ได้รับการยืนยัน",
    "fullNamePlaceholder": "ป้อนชื่อ-นามสกุลเต็มของคุณ",
    "contactNumber": "หมายเลขที่ติดต่อ",
    "chooseContact": "เลือกวิธีการติดต่อ:",
    "both": "ทั้งสอง",
    "whatsappPlaceholder": "เช่น +1... / +44... / +880... (หมายเลข WhatsApp พร้อมรหัสประเทศ)",
    "telegramPlaceholder": "เช่น +1... / +880... หรือ @username (หมายเลขหรือชื่อผู้ใช้ Telegram)",
    "phonePlaceholder": "เช่น +1... / +44... / +880... (หมายเลขพร้อมรหัสประเทศ)",
    "contactNote": "ให้หมายเลขที่ใช้งานได้ผ่านวิธีที่เลือกสำหรับการแจ้งเตือนและการสื่อสารด่วน",
    "identityVerification": "การยืนยันตัวตน",
    "birthCertificate": "สูติบัตร",
    "nidCard": "บัตรประจำตัวประชาชน (NID)",
    "birthNumber": "หมายเลขสูติบัตร (ไม่ซ้ำ)",
    "birthPlaceholder": "ป้อนหมายเลขสูติบัตร",
    "nidNumber": "หมายเลข NID (ไม่ซ้ำ)",
    "nidPlaceholder": "ป้อนหมายเลข NID",
    "front": "ด้านหน้า",
    "back": "ด้านหลัง",
    "liveSelfie": "รูปเซลฟี่สดหน้าตรง (ขนาดพาสปอร์ต)",
    "liveCameraOnly": "เฉพาะกล้องสด",
    "selfieInstruction": "หันหน้าเข้ากล้องและถ่ายเซลฟี่สดในสภาพแสงที่ชัดเจน",
    "noSelfie": "ยังไม่มีเซลฟี่",
    "retakeSelfie": "ถ่ายเซลฟี่สดใหม่",
    "takeSelfie": "ถ่ายเซลฟี่ด้วยกล้องหน้าแบบสด",
    "selfieWarning": "เพื่อป้องกันการฉ้อโกง รูปเซลฟี่ต้องถ่ายด้วยกล้องสดเท่านั้น (ปิดการอัปโหลดจากแกลเลอรี)",
    "selfieTip": "หลีกเลี่ยงการสวมแว่นหรือหน้ากากขณะถ่ายและตรวจสอบให้แน่ใจว่ามีแสงเพียงพอ",
    "saveUpdating": "กำลังบันทึกและอัปเดต...",
    "updateLinks": "อัปเดตข้อมูลและลิงก์โซเชียล",
    "cameraSuccess": "ถ่ายรูปสำเร็จด้วยกล้องสด!",
    "errorPrefix": "ข้อผิดพลาด:",
    "criticalWarning": "คำเตือนร้ายแรง & แนวทางปฏิบัติ",
    "rules": [
      "ผู้สมัครที่มีอายุ 18 ปีขึ้นไปต้องส่งทั้ง NID และสูติบัตร; สูติบัตรเพียงอย่างเดียวไม่เพียงพอ",
      "ผู้สมัครที่อายุต่ำกว่า 18 ปีต้องส่งเฉพาะสูติบัตรและเซลฟี่สดของหน้า",
      "สูติบัตรต้องแสดงปีเกิด 2010 หรือก่อนหน้า",
      "อายุที่คำนวณจากวันเกิดบน NID ต้องไม่มากกว่า 40 ปี; บัญชีที่อายุมากกว่า 40 จะไม่ถูกยืนยัน",
      "ข้อมูลและใบรับรองที่ส่งจะถูกตรวจสอบกับบันทึกออนไลน์ของรัฐบาลที่มีอยู่ ข้อมูลไม่ถูกต้อง ภาพไม่ชัดหรือถูกแก้ไข หรือความไม่ตรงกันจะไม่ได้รับการอนุมัติ",
      "อนุมัติได้เพียงบัญชีเดียวต่อ NID หรือสูติบัตรเท่านั้น ห้ามมีบัญชีซ้ำ"
    ],
    "age18": "มากกว่า 18 (18+)",
    "under18": "ต่ำกว่า 18",
    "zoom": "ดูแบบขยาย",
    "notUploaded": "ยังไม่ได้อัปโหลดรูปภาพ",
    "uploadGallery": "อัปโหลดจากไฟล์ / แกลเลอรี",
    "uploadDevice": "อัปโหลดรูปจากอุปกรณ์"
  },
  "vi": {
    "subtitle": "Quản lý hồ sơ doanh nghiệp và xác minh bảo mật",
    "rejectedTitle": "Yêu cầu xác minh trước đó đã bị từ chối",
    "adminNote": "Ghi chú quản trị:",
    "rejectedReason": "Có sự không nhất quán trong thông tin hoặc hình ảnh. Vui lòng chụp ảnh rõ bằng camera trực tiếp và gửi lại.",
    "pendingTitle": "Tài liệu định danh đang được xem xét — bảng điều khiển đã mở khóa",
    "pendingBody": "Thông tin và hình ảnh bạn gửi đã được nhận thành công và sẽ được xác minh với hồ sơ chính phủ bởi bảng quản trị trong vòng 24 giờ.",
    "pendingStrong": "Bảng điều khiển của bạn đã được mở khóa hoàn toàn nên bạn có thể sử dụng tất cả tính năng.",
    "pendingTail": "Quản trị viên có quyền khóa tài khoản nếu bất kỳ thông tin nào được phát hiện là sai hoặc không chính xác.",
    "unlockTitle": "Cung cấp thông tin và tài liệu định danh dưới đây để mở khóa đầy đủ bảng điều khiển",
    "unlockBody": "Hoàn thành thông tin bên dưới, NID hoặc giấy khai sinh, và ảnh selfie trực tiếp khuôn mặt, sau đó nhấn \"Save Profile & Documents\" để mở khóa tất cả tính năng của bảng điều khiển ngay lập tức. Quản trị viên sẽ xác minh thông tin của bạn với hồ sơ chính phủ và cấp phê duyệt cuối cùng trong vòng 24 giờ.",
    "verifiedMerchant": "Thương nhân đã xác minh",
    "underReview": "Đang xem xét xác minh (Bảng điều khiển đã mở khóa)",
    "rejected": "Xác minh bị từ chối (Cần hành động)",
    "unverified": "Hồ sơ chưa được xác minh",
    "fullNamePlaceholder": "Nhập họ và tên đầy đủ",
    "contactNumber": "Số liên hệ",
    "chooseContact": "Chọn phương thức liên hệ:",
    "both": "Cả hai",
    "whatsappPlaceholder": "ví dụ +1... / +44... / +880... (số WhatsApp có mã quốc gia)",
    "telegramPlaceholder": "ví dụ +1... / +880... hoặc @username (số hoặc tên người dùng Telegram)",
    "phonePlaceholder": "ví dụ +1... / +44... / +880... (số có mã quốc gia)",
    "contactNote": "Cung cấp số đang hoạt động qua phương thức đã chọn để nhận thông báo và liên lạc khẩn cấp.",
    "identityVerification": "Xác minh danh tính",
    "birthCertificate": "Giấy khai sinh",
    "nidCard": "Chứng minh nhân dân quốc gia (NID)",
    "birthNumber": "Số giấy khai sinh (Duy nhất)",
    "birthPlaceholder": "Nhập số giấy khai sinh",
    "nidNumber": "Số NID (Duy nhất)",
    "nidPlaceholder": "Nhập số NID",
    "front": "Mặt trước",
    "back": "Mặt sau",
    "liveSelfie": "Ảnh selfie trực tiếp khuôn mặt (Kích thước hộ chiếu)",
    "liveCameraOnly": "Chỉ camera trực tiếp",
    "selfieInstruction": "Nhìn vào camera và chụp selfie trực tiếp trong ánh sáng rõ.",
    "noSelfie": "Chưa có selfie",
    "retakeSelfie": "Chụp lại selfie trực tiếp",
    "takeSelfie": "Chụp selfie bằng camera trước trực tiếp",
    "selfieWarning": "Để ngăn gian lận, ảnh selfie khuôn mặt phải được chụp bằng camera trực tiếp (không cho phép tải từ thư viện).",
    "selfieTip": "Tránh đeo kính hoặc khẩu trang khi chụp và đảm bảo đủ ánh sáng.",
    "saveUpdating": "Đang lưu và cập nhật...",
    "updateLinks": "Cập nhật thông tin và liên kết mạng xã hội",
    "cameraSuccess": "Ảnh đã được chụp thành công bằng camera trực tiếp!",
    "errorPrefix": "Lỗi:",
    "criticalWarning": "CẢNH BÁO NGHIÊM TRỌNG & HƯỚNG DẪN",
    "rules": [
      "Người nộp đơn từ 18 tuổi trở lên phải cung cấp cả NID và giấy khai sinh; chỉ giấy khai sinh là không đủ.",
      "Người nộp đơn dưới 18 tuổi chỉ phải cung cấp giấy khai sinh và ảnh selfie trực tiếp khuôn mặt.",
      "Giấy khai sinh phải hiển thị năm sinh 2010 hoặc trước đó.",
      "Tuổi tính theo ngày sinh trên NID không được vượt quá 40 tuổi; các tài khoản trên 40 tuổi sẽ không được xác minh.",
      "Thông tin và giấy tờ gửi lên sẽ được kiểm tra với hồ sơ chính phủ trực tuyến có sẵn. Thông tin sai, hình ảnh mờ hoặc bị chỉnh sửa, hoặc không khớp sẽ không được chấp thuận.",
      "Chỉ một tài khoản được chấp thuận cho mỗi NID hoặc giấy khai sinh. Cấm có tài khoản trùng lặp."
    ],
    "age18": "Trên 18 (18+)",
    "under18": "Dưới 18",
    "zoom": "Xem lớn hơn",
    "notUploaded": "Chưa tải ảnh lên",
    "uploadGallery": "Tải lên từ tệp / thư viện",
    "uploadDevice": "Tải ảnh từ thiết bị"
  },
  "uk": {
    "subtitle": "Керуйте профілем бізнесу та перевіркою безпеки",
    "rejectedTitle": "Попередня заява на верифікацію була відхилена",
    "adminNote": "Примітка адміністратора:",
    "rejectedReason": "Виявлено невідповідність у даних або зображеннях. Будь ласка, зробіть чітке фото з живої камери та подайте повторно.",
    "pendingTitle": "Документи особи на перевірці — інформаційна панель розблоковано",
    "pendingBody": "Надана вами інформація та зображення успішно отримані й будуть перевірені за державними записами в адмінпанелі протягом 24 годин.",
    "pendingStrong": "Ваша панель уже повністю розблокована, тож ви можете користуватися всіма функціями.",
    "pendingTail": "Адміністратор залишає за собою право заблокувати акаунт, якщо будь-яка інформація виявиться недостовірною або неточною.",
    "unlockTitle": "Надайте інформацію та документи нижче, щоб повністю розблокувати панель",
    "unlockBody": "Заповніть інформацію нижче, NID або свідоцтво про народження та живе селфі, потім натисніть \"Save Profile & Documents\", щоб негайно розблокувати всі функції панелі. Адмін перевірить вашу інформацію за державними записами та надасть остаточне підтвердження протягом 24 годин.",
    "verifiedMerchant": "Підтверджений продавець",
    "underReview": "Верифікація на перевірці (Панель розблоковано)",
    "rejected": "Верифікація відхилена (Потрібна дія)",
    "unverified": "Непідтверджений профіль",
    "fullNamePlaceholder": "Введіть ваше повне ім’я",
    "contactNumber": "Контактний номер",
    "chooseContact": "Оберіть спосіб зв’язку:",
    "both": "Обидва",
    "whatsappPlaceholder": "наприклад +1... / +44... / +880... (номер WhatsApp з кодом країни)",
    "telegramPlaceholder": "наприклад +1... / +880... або @username (номер або ім’я в Telegram)",
    "phonePlaceholder": "наприклад +1... / +44... / +880... (номер з кодом країни)",
    "contactNote": "Надайте активний номер через обраний спосіб для термінових сповіщень та зв’язку.",
    "identityVerification": "Перевірка особи",
    "birthCertificate": "Свідоцтво про народження",
    "nidCard": "Національний ID (NID-картка)",
    "birthNumber": "Номер свідоцтва про народження (унікальний)",
    "birthPlaceholder": "Введіть номер свідоцтва про народження",
    "nidNumber": "NID номер (унікальний)",
    "nidPlaceholder": "Введіть NID номер",
    "front": "Перед",
    "back": "Задня",
    "liveSelfie": "Живе селфі (паспортного розміру)",
    "liveCameraOnly": "Тільки жива камера",
    "selfieInstruction": "Подивіться в камеру і зробіть живе селфі при хорошому освітленні.",
    "noSelfie": "Селфі відсутнє",
    "retakeSelfie": "Зробити селфі заново",
    "takeSelfie": "Зробити селфі живою фронтальною камерою",
    "selfieWarning": "Щоб запобігти шахрайству, селфі має бути зроблене лише живою камерою (завантаження з галереї вимкнено).",
    "selfieTip": "Не користуйтеся окулярами або маскою під час зйомки та забезпечте достатнє освітлення.",
    "saveUpdating": "Збереження та оновлення...",
    "updateLinks": "Оновити інформацію та посилання соцмереж",
    "cameraSuccess": "Фото успішно зроблене живою камерою!",
    "errorPrefix": "Помилка:",
    "criticalWarning": "КРИТИЧНЕ ПОПЕРЕДЖЕННЯ ТА ІНСТРУКЦІЇ",
    "rules": [
      "Заявники віком 18 років і старше повинні надати як NID, так і свідоцтво про народження; лише свідоцтво про народження є недостатнім.",
      "Заявники молодше 18 років повинні надати лише свідоцтво про народження та живе селфі.",
      "Свідоцтво про народження має вказувати рік народження 2010 або раніше.",
      "Вік, обчислений за датою народження в NID, не повинен перевищувати 40 років; акаунти старші за 40 років не будуть верифіковані.",
      "Надана інформація та сертифікати будуть перевірені з доступними державними онлайн-записами. Неправильна інформація, нечіткі або змінені зображення чи невідповідності не будуть схвалені.",
      "Може бути схвалений лише один акаунт на один NID або свідоцтво про народження. Дублікати акаунтів заборонені."
    ],
    "age18": "Від 18 років (18+)",
    "under18": "Менше 18",
    "zoom": "Переглянути більше",
    "notUploaded": "Зображення ще не завантажено",
    "uploadGallery": "Завантажити з файлу / галереї",
    "uploadDevice": "Завантажити фото з пристрою"
  },
  "pl": {
    "subtitle": "Zarządzaj profilem firmy i weryfikacją bezpieczeństwa",
    "rejectedTitle": "Poprzedni wniosek weryfikacyjny został odrzucony",
    "adminNote": "Uwaga administratora:",
    "rejectedReason": "Wystąpiła niezgodność w informacjach lub obrazach. Proszę wykonać wyraźne zdjęcie żywą kamerą i przesłać ponownie.",
    "pendingTitle": "Dokumenty tożsamości w trakcie weryfikacji — panel odblokowany",
    "pendingBody": "Przesłane informacje i zdjęcia zostały pomyślnie odebrane i zostaną zweryfikowane z rejestrami państwowymi w panelu administracyjnym w ciągu 24 godzin.",
    "pendingStrong": "Twój panel został już w pełni odblokowany, więc możesz korzystać ze wszystkich funkcji.",
    "pendingTail": "Administrator zastrzega sobie prawo do zablokowania konta, jeśli jakiekolwiek informacje okażą się fałszywe lub nieprecyzyjne.",
    "unlockTitle": "Podaj poniższe informacje i dokumenty tożsamości, aby całkowicie odblokować panel",
    "unlockBody": "Uzupełnij poniższe dane, NID lub akt urodzenia oraz żywe selfie twarzy, a następnie kliknij \"Save Profile & Documents\", aby natychmiast odblokować wszystkie funkcje panelu. Administrator zweryfikuje Twoje dane z rejestrami państwowymi i udzieli ostatecznej zgody w ciągu 24 godzin.",
    "verifiedMerchant": "Zweryfikowany sprzedawca",
    "underReview": "Weryfikacja w toku (Panel odblokowany)",
    "rejected": "Weryfikacja odrzucona (Wymagana akcja)",
    "unverified": "Niezweryfikowany profil",
    "fullNamePlaceholder": "Wpisz pełne imię i nazwisko",
    "contactNumber": "Numer kontaktowy",
    "chooseContact": "Wybierz metodę kontaktu:",
    "both": "Obie",
    "whatsappPlaceholder": "np. +1... / +44... / +880... (numer WhatsApp z kodem kraju)",
    "telegramPlaceholder": "np. +1... / +880... lub @username (numer lub nazwa w Telegramie)",
    "phonePlaceholder": "np. +1... / +44... / +880... (numer z kodem kraju)",
    "contactNote": "Podaj aktywny numer przy wybranej metodzie do pilnych powiadomień i komunikacji.",
    "identityVerification": "Weryfikacja tożsamości",
    "birthCertificate": "Akt urodzenia",
    "nidCard": "Dowód krajowy (NID)",
    "birthNumber": "Numer aktu urodzenia (unikalny)",
    "birthPlaceholder": "Wpisz numer aktu urodzenia",
    "nidNumber": "Numer NID (unikalny)",
    "nidPlaceholder": "Wpisz numer NID",
    "front": "Przód",
    "back": "Tył",
    "liveSelfie": "Żywe zdjęcie twarzy (rozmiar paszportowy)",
    "liveCameraOnly": "Tylko żywa kamera",
    "selfieInstruction": "Spójrz w kamerę i zrób żywe selfie przy dobrym oświetleniu.",
    "noSelfie": "Brak selfie",
    "retakeSelfie": "Zrób selfie ponownie",
    "takeSelfie": "Zrób selfie przednią kamerą na żywo",
    "selfieWarning": "Aby zapobiec oszustwom, selfie musi być wykonane tylko żywą kamerą (przesyłanie z galerii wyłączone).",
    "selfieTip": "Unikaj noszenia okularów lub maski podczas robienia zdjęcia i zapewnij odpowiednie oświetlenie.",
    "saveUpdating": "Zapisywanie i aktualizowanie...",
    "updateLinks": "Zaktualizuj informacje i linki społecznościowe",
    "cameraSuccess": "Zdjęcie wykonane pomyślnie żywą kamerą!",
    "errorPrefix": "Błąd:",
    "criticalWarning": "KRYTYCZNE OSTRZEŻENIE I ZASADY",
    "rules": [
      "Wnioskodawcy w wieku 18 lat i powyżej muszą dostarczyć zarówno NID, jak i akt urodzenia; sam akt urodzenia nie wystarcza.",
      "Wnioskodawcy poniżej 18 lat muszą dostarczyć tylko akt urodzenia i żywe selfie twarzy.",
      "Akt urodzenia musi wskazywać rok urodzenia 2010 lub wcześniejszy.",
      "Wiek obliczony na podstawie daty urodzenia w NID nie może przekraczać 40 lat; konta starsze niż 40 lat nie będą weryfikowane.",
      "Przesłane informacje i certyfikaty zostaną sprawdzone z dostępnymi rządowymi rejestrami online. Nieprawidłowe informacje, nieczytelne lub zmienione obrazy bądź niezgodności nie zostaną zatwierdzone.",
      "Na jeden NID lub akt urodzenia może zostać zatwierdzone tylko jedno konto. Konta duplikowane są zabronione."
    ],
    "age18": "Powyżej 18 (18+)",
    "under18": "Poniżej 18",
    "zoom": "Powiększ",
    "notUploaded": "Obraz nie został jeszcze przesłany",
    "uploadGallery": "Prześlij z pliku / galerii",
    "uploadDevice": "Prześlij zdjęcie z urządzenia"
  },
  "el": {
    "subtitle": "Διαχειριστείτε το προφίλ της επιχείρησής σας και τον έλεγχο ασφαλείας",
    "rejectedTitle": "Η προηγούμενη αίτηση επαλήθευσης απορρίφθηκε",
    "adminNote": "Σημείωμα διαχειριστή:",
    "rejectedReason": "Υπήρξε ασυμφωνία στις πληροφορίες ή τις εικόνες. Παρακαλώ τραβήξτε ξεκάθαρη φωτογραφία με την ζωντανή κάμερα και υποβάλετε ξανά.",
    "pendingTitle": "Τα έγγραφα ταυτότητας εξετάζονται — πίνακας ξεκλείδωσε",
    "pendingBody": "Οι υποβληθείσες πληροφορίες και εικόνες ελήφθησαν επιτυχώς και θα επαληθευτούν με τα κρατικά αρχεία από το πάνελ διαχείρισης εντός 24 ωρών.",
    "pendingStrong": "Ο πίνακάς σας έχει ήδη ξεκλειδωθεί πλήρως ώστε να μπορείτε να χρησιμοποιείτε όλες τις λειτουργίες.",
    "pendingTail": "Ο διαχειριστής διατηρεί το δικαίωμα να αποκλείσει έναν λογαριασμό εάν οποιαδήποτε πληροφορία βρεθεί ψευδής ή ανακριβής.",
    "unlockTitle": "Παρέχετε τις παρακάτω πληροφορίες και έγγραφα ταυτότητας για να ξεκλειδώσετε πλήρως τον πίνακα",
    "unlockBody": "Συμπληρώστε τις παρακάτω πληροφορίες, NID ή πιστοποιητικό γέννησης και ζωντανό selfie προσώπου, στη συνέχεια κάντε κλικ \"Save Profile & Documents\" για να ξεκλειδώσετε άμεσα όλες τις λειτουργίες του πίνακα. Ο διαχειριστής θα επαληθεύσει τις πληροφορίες σας με τα κρατικά αρχεία και θα δώσει τελική έγκριση εντός 24 ωρών.",
    "verifiedMerchant": "Επαληθευμένος Έμπορος",
    "underReview": "Επαλήθευση Υπό Έλεγχο (Πίνακας Ξεκλείδωσε)",
    "rejected": "Επαλήθευση Απορρίφθηκε (Απαιτείται Δράση)",
    "unverified": "Μη Επαληθευμένο Προφίλ",
    "fullNamePlaceholder": "Εισάγετε το πλήρες όνομά σας",
    "contactNumber": "Αριθμός επικοινωνίας",
    "chooseContact": "Επιλέξτε μέθοδο επικοινωνίας:",
    "both": "Και τα δύο",
    "whatsappPlaceholder": "π.χ. +1... / +44... / +880... (αριθμός WhatsApp με κωδικό χώρας)",
    "telegramPlaceholder": "π.χ. +1... / +880... ή @username (αριθμός ή όνομα χρήστη στο Telegram)",
    "phonePlaceholder": "π.χ. +1... / +44... / +880... (αριθμός με κωδικό χώρας)",
    "contactNote": "Παρέχετε ενεργό αριθμό μέσω της επιλεγμένης μεθόδου για επείγοντα μηνύματα και επικοινωνία.",
    "identityVerification": "Επαλήθευση Ταυτότητας",
    "birthCertificate": "Πιστοποιητικό Γέννησης",
    "nidCard": "Εθνικό Δελτίο Ταυτότητας (NID)",
    "birthNumber": "Αριθμός πιστοποιητικού γέννησης (μοναδικός)",
    "birthPlaceholder": "Εισάγετε τον αριθμό πιστοποιητικού γέννησης",
    "nidNumber": "Αριθμός NID (μοναδικός)",
    "nidPlaceholder": "Εισάγετε τον αριθμό NID",
    "front": "Μπροστά",
    "back": "Πίσω",
    "liveSelfie": "Ζωντανή φωτογραφία προσώπου (μέγεθος διαβατηρίου)",
    "liveCameraOnly": "Μόνο ζωντανή κάμερα",
    "selfieInstruction": "Κοιτάξτε την κάμερα και τραβήξτε ζωντανό selfie σε καθαρό φωτισμό.",
    "noSelfie": "Χωρίς selfie",
    "retakeSelfie": "Τραβήξτε ξανά το ζωντανό selfie",
    "takeSelfie": "Τραβήξτε selfie με την μπροστινή ζωντανή κάμερα",
    "selfieWarning": "Για την αποφυγή απάτης, το selfie πρέπει να τραβηχτεί μόνο με την ζωντανή κάμερα (αποστολή από γκαλερί απενεργοποιημένη).",
    "selfieTip": "Αποφύγετε τα γυαλιά ή τη μάσκα κατά τη λήψη και εξασφαλίστε επαρκή φωτισμό.",
    "saveUpdating": "Αποθήκευση και ενημέρωση...",
    "updateLinks": "Ενημέρωση πληροφοριών και κοινωνικών συνδέσμων",
    "cameraSuccess": "Η φωτογραφία τραβήχτηκε με επιτυχία με τη ζωντανή κάμερα!",
    "errorPrefix": "Σφάλμα:",
    "criticalWarning": "ΚΡΙΣΙΜΗ ΠΡΟΕΙΔΟΠΟΙΗΣΗ & ΟΔΗΓΙΕΣ",
    "rules": [
      "Οι αιτούντες ηλικίας 18 ετών και άνω πρέπει να προσκομίσουν τόσο NID όσο και πιστοποιητικό γέννησης· μόνο το πιστοποιητικό γέννησης δεν επαρκεί.",
      "Οι αιτούντες κάτω των 18 πρέπει να προσκομίσουν μόνο πιστοποιητικό γέννησης και ζωντανό selfie προσώπου.",
      "Το πιστοποιητικό γέννησης πρέπει να δείχνει έτος γέννησης 2010 ή νωρίτερα.",
      "Η ηλικία που υπολογίζεται από την ημερομηνία γέννησης στο NID δεν πρέπει να υπερβαίνει τα 40 έτη· λογαριασμοί άνω των 40 δεν θα επαληθευτούν.",
      "Οι υποβληθείσες πληροφορίες και πιστοποιητικά θα ελεγχθούν με τα διαθέσιμα κυβερνητικά ηλεκτρονικά αρχεία. Λανθασμένες πληροφορίες, ανεπαρκείς ή αλλοιωμένες εικόνες ή ασυμφωνίες δεν θα εγκριθούν.",
      "Μόνο ένας λογαριασμός μπορεί να εγκριθεί ανά NID ή πιστοποιητικό γέννησης. Τα διπλότυπα απαγορεύονται."
    ],
    "age18": "Πάνω από 18 (18+)",
    "under18": "Κάτω των 18",
    "zoom": "Προβολή σε μεγέθυνση",
    "notUploaded": "Δεν έχει ανέβει εικόνα ακόμη",
    "uploadGallery": "Μεταφόρτωση από αρχείο / γκαλερί",
    "uploadDevice": "Μεταφόρτωση φωτογραφίας από τη συσκευή"
  },
  "he": {
    "subtitle": "נהל את פרופיל העסק שלך ואימות האבטחה",
    "rejectedTitle": "בקשת האימות הקודמת נרשלה",
    "adminNote": "הערת מנהל:",
    "rejectedReason": "התגלתה אי־התאמה במידע או בתמונות. אנא צלם תמונה ברורה עם המצלמה החיה ושלח שוב.",
    "pendingTitle": "מסמכי זהות בבדיקה — לוח המחוונים פתוח",
    "pendingBody": "המידע והתמונות שהוגשו התקבלו בהצלחה וייבדקו מול רישומי הממשלה דרך לוח המנהלים תוך 24 שעות.",
    "pendingStrong": "לוח המחוונים שלך כבר נפתח במלואו כך שאתה יכול להשתמש בכל הפונקציות.",
    "pendingTail": "המנהל שומר לעצמו את הזכות לחסום חשבון אם יימצא שכל מידע הוא שקרי או לא מדויק.",
    "unlockTitle": "ספק את המידע והמסמכי זהות שלמטה כדי לפתוח את לוח המחוונים במלואו",
    "unlockBody": "מלא את המידע למטה, NID או תעודת לידה, וסלפי חי של הפנים, ואז לחץ \"Save Profile & Documents\" כדי לפתוח מיידית את כל פונקציות הלוח. המנהל יוודא את המידע מול רישומי הממשלה וייתן אישור סופי בתוך 24 שעות.",
    "verifiedMerchant": "מוכר מאומת",
    "underReview": "אימות בבדיקה (לוח המחוונים פתוח)",
    "rejected": "אימות נדחה (נדרשת פעולה)",
    "unverified": "פרופיל לא מאומת",
    "fullNamePlaceholder": "הכנס את שמך המלא",
    "contactNumber": "מספר ליצירת קשר",
    "chooseContact": "בחר שיטת קשר:",
    "both": "שניהם",
    "whatsappPlaceholder": "למשל +1... / +44... / +880... (מספר WhatsApp עם קידומת מדינה)",
    "telegramPlaceholder": "למשל +1... / +880... או @username (מספר או שם משתמש ב‑Telegram)",
    "phonePlaceholder": "למשל +1... / +44... / +880... (מספר עם קידומת מדינה)",
    "contactNote": "ספק מספר פעיל באמצעות השיטה הנבחרת לקבלת הודעות דחופות ותקשורת.",
    "identityVerification": "אימות זהות",
    "birthCertificate": "תעודת לידה",
    "nidCard": "תעודת זהות לאומית (NID)",
    "birthNumber": "מספר תעודת הלידה (ייחודי)",
    "birthPlaceholder": "הכנס את מספר תעודת הלידה",
    "nidNumber": "מספר NID (ייחודי)",
    "nidPlaceholder": "הכנס את מספר NID",
    "front": "חזית",
    "back": "אחורי",
    "liveSelfie": "תמונת סלפי חיה של הפנים (גודל פספורט)",
    "liveCameraOnly": "רק מצלמה חיה",
    "selfieInstruction": "הביט למצלמה וצילם סלפי חי באור מספק.",
    "noSelfie": "אין סלפי",
    "retakeSelfie": "צלם סלפי חי שוב",
    "takeSelfie": "צור סלפי עם מצלמת החזית החיה",
    "selfieWarning": "כדי למנוע הונאה, הסלפי חייב להילקח רק במצלמה החיה (העלאה מהגלריה מושבתת).",
    "selfieTip": "הימנע מללבוש משקפיים או מסכה בעת הצילום ודא תאורה מספקת.",
    "saveUpdating": "שומר ומעדכן...",
    "updateLinks": "עדכן מידע וקישורי רשתות חברתיות",
    "cameraSuccess": "התמונה צולמה בהצלחה במצלמה החיה!",
    "errorPrefix": "שגיאה:",
    "criticalWarning": "אזהרה קריטית והנחיות",
    "rules": [
      "מבקשים בגיל 18 ומעלה חייבים לספק גם NID וגם תעודת לידה; תעודת לידה בלבד אינה מספיקה.",
      "מבקשים מתחת לגיל 18 חייבים לספק רק תעודת לידה וסלפי חי של הפנים.",
      "תעודת הלידה חייבת להראות שנת לידה 2010 או קודם.",
      "הגיל המחושב מתאריך הלידה ב‑NID לא צריך להיות יותר מ‑40 שנה; חשבונות מעל 40 לא יאומתו.",
      "המידע והתעודות שיוגשו ייבדקו מול רישומי הממשלה הזמינים באינטרנט. מידע שגוי, תמונות מטושטשות או ערוכות, או אי‑התאמות לא יאושרו.",
      "ניתן לאשר חשבון אחד בלבד לכל NID או תעודת לידה. חשבונות כפולים אסורים."
    ],
    "age18": "מעל 18 (18+)",
    "under18": "מתחת ל‑18",
    "zoom": "הצג בגדול",
    "notUploaded": "עדיין לא הועלתה תמונה",
    "uploadGallery": "העלה מקובץ / גלריה",
    "uploadDevice": "העלה תמונה מהמכשיר"
  },
  "ne": {
    "subtitle": "आफ्नो व्यवसाय प्रोफाइल र सुरक्षा प्रमाणीकरण व्यवस्थापन गर्नुहोस्",
    "rejectedTitle": "पहिलेको प्रमाणीकरण आवेदन अस्वीकृत भयो",
    "adminNote": "प्रशासक नोट:",
    "rejectedReason": "जानकारी वा तस्वीरहरूमा असंगति थियो। कृपया प्रत्यक्ष क्यामेराबाट स्पष्ट फोटो लिनुहोस् र पुन: पेश गर्नुहोस्।",
    "pendingTitle": "पहिचान कागजातहरू समीक्षा अन्तर्गत — ड्यासबोर्ड अनलक गरिएको",
    "pendingBody": "तपाईंले पेश गर्नुभएको जानकारी र तस्वीरहरू सफलतापूर्वक प्राप्त भएका छन् र प्रशासनिक प्यानलद्वारा २४ घण्टाभित्र सरकारी अभिलेखसँग मिलेर प्रमाणित गरिनेछ।",
    "pendingStrong": "तपाईंको ड्यासबोर्ड पहिले नै पूर्ण रूपमा अनलक गरिएको छ ताकि तपाईं सबै सुविधाहरू प्रयोग गर्न सक्नुहुन्छ।",
    "pendingTail": "यदि कुनै जानकारी गलत वा असत्य ठहरिएको खण्डमा प्रशासनले खाता ब्लक गर्ने अधिकार राख्छ।",
    "unlockTitle": "तपाईंको ड्यासबोर्ड पूर्ण रूपमा अनलक गर्न तलको जानकारी र पहिचान कागजातहरू प्रदान गर्नुहोस्",
    "unlockBody": "तलको जानकारी, NID वा जन्म प्रमाणपत्र, र प्रत्यक्ष अनुहार सेल्फी पूरा गर्नुहोस्, त्यसपछि सबै ड्यासबोर्ड सुविधाहरू तुरुन्त अनलक गर्न \"Save Profile & Documents\" मा क्लिक गर्नुहोस्। प्रशासनले तपाईंको जानकारी सरकारी अभिलेखसँग मिलाएर २४ घण्टाभित्र अन्तिम अनुमोदन दिनेछ।",
    "verifiedMerchant": "प्रमाणित व्यापारी",
    "underReview": "प्रमाणीकरण समीक्षा अन्तर्गत (ड्यासबोर्ड अनलक गरिएको)",
    "rejected": "प्रमाणीकरण अस्वीकृत (कार्य आवश्यक)",
    "unverified": "अप्रमाणित प्रोफाइल",
    "fullNamePlaceholder": "तपाईंको पूरा नाम प्रविष्ट गर्नुहोस्",
    "contactNumber": "सम्पर्क नम्बर",
    "chooseContact": "सम्पर्क विधि चयन गर्नुहोस्:",
    "both": "दुवै",
    "whatsappPlaceholder": "उदाहरण: +1... / +44... / +880... (देश कोड सहित WhatsApp नम्बर)",
    "telegramPlaceholder": "उदाहरण: +1... / +880... वा @username (Telegram नम्बर वा प्रयोगकर्ता नाम)",
    "phonePlaceholder": "उदाहरण: +1... / +44... / +880... (देश कोड सहित नम्बर)",
    "contactNote": "जरुरी सूचना र सञ्चारका लागि चयन गरिएको विधिबाट सक्रिय नम्बर प्रदान गर्नुहोस्।",
    "identityVerification": "पहिचान प्रमाणीकरण",
    "birthCertificate": "जन्म प्रमाणपत्र",
    "nidCard": "राष्ट्रिय परिचयपत्र (NID कार्ड)",
    "birthNumber": "जन्म प्रमाणपत्र नम्बर (अद्वितीय)",
    "birthPlaceholder": "जन्म प्रमाणपत्र नम्बर प्रविष्ट गर्नुहोस्",
    "nidNumber": "NID नम्बर (अद्वितीय)",
    "nidPlaceholder": "NID नम्बर प्रविष्ट गर्नुहोस्",
    "front": "अगाडि",
    "back": "पछाडि",
    "liveSelfie": "प्रत्यक्ष अनुहार सेल्फी फोटो (पासपोर्ट साइज)",
    "liveCameraOnly": "प्रत्यक्ष क्यामेरा मात्र",
    "selfieInstruction": "क्यामेरातर्फ हेर्नुहोस् र स्पष्ट प्रकाशमा प्रत्यक्ष सेल्फी लिनुहोस्।",
    "noSelfie": "सेल्फी छैन",
    "retakeSelfie": "प्रत्यक्ष सेल्फी फेरि लिनुहोस्",
    "takeSelfie": "प्रत्यक्ष फ्रन्ट क्यामेराबाट सेल्फी लिनुहोस्",
    "selfieWarning": "ठगी रोक्नका लागि अनुहारको सेल्फी केवल प्रत्यक्ष क्यामेराबाट लिनुपर्छ (ग्यालेरी अपलोड अक्षम)।",
    "selfieTip": "फोटो लिँदा चस्मा वा मास्क नलगाउनुहोस् र पर्याप्त प्रकाश सुनिश्चित गर्नुहोस्।",
    "saveUpdating": "सुरक्षित गर्दै र अद्यावधिक गर्दै...",
    "updateLinks": "जानकारी र सामाजिक लिङ्कहरू अद्यावधिक गर्नुहोस्",
    "cameraSuccess": "प्रत्यक्ष क्यामेराबाट फोटो सफलतापूर्वक कैद भयो!",
    "errorPrefix": "त्रुटि:",
    "criticalWarning": "गम्भीर चेतावनी र मार्गदर्शनहरू",
    "rules": [
      "१८ वर्ष वा माथिका आवेदनकर्ताले NID र जन्म प्रमाणपत्र दुवै प्रदान गर्नुपर्छ; केवल जन्म प्रमाणपत्र पर्याप्त छैन।",
      "१८ वर्षभन्दा कम उमेरका आवेदनकर्ताले मात्र जन्म प्रमाणपत्र र प्रत्यक्ष अनुहार सेल्फी प्रदान गर्नुपर्छ।",
      "जन्म प्रमाणपत्रमा जन्म वर्ष २०१० वा पहिलेको देखिनुपर्छ।",
      "NID को जन्म मिति अनुसार गणना गरिएको उमेर ४० वर्ष भन्दा बढी हुनु हुँदैन; ४० भन्दा माथिका खाताहरू प्रमाणीकरण हुँदैनन्।",
      "पेश गरिएको जानकारी र प्रमाणपत्रहरू उपलब्ध सरकारी अनलाइन अभिलेखसँग जाँचिनेछन्। गलत जानकारी, अस्पष्ट वा परिवर्तन गरिएका तस्वीरहरू, वा मेल नखाने बस्तुहरू स्वीकृत हुने छैनन्।",
      "प्रत्येक NID वा जन्म प्रमाणपत्रका लागि केवल एक खाता मात्र स्वीकृत हुन सक्छ। नक्कली वा दोहोरिएर खाताहरू निषेध छन्।"
    ],
    "age18": "१८ वर्ष माथि (१८+)",
    "under18": "१८ वर्ष मुनि",
    "zoom": "ठूलो दृश्य हेर्नुहोस्",
    "notUploaded": "अहिलेसम्म कुनै छवि अपलोड गरिएको छैन",
    "uploadGallery": "फाइल/ग्यालेरीबाट अपलोड गर्नुहोस्",
    "uploadDevice": "यन्त्रबाट फोटो अपलोड गर्नुहोस्"
  },
  "si": {
    "subtitle": "ඔබේ ව්යාපාරයේ පැතිකඩ සහ ආරක්ෂක හැඳුනුම් තහවුරු කිරීම කළමනාකරණය කරන්න",
    "rejectedTitle": "පෙර තහවුරු කිරීමේ අයදුම ප්‍රතික්ෂේප කර ඇත",
    "adminNote": "පරිපාලක සටහන:",
    "rejectedReason": "තොරතුරු හෝ රූප වල සමාන්‍යතාවයක් නොතිබුණි. කරුණාකර සජීවී කැමරාපිට අවශ‍්‍ය පටිගත කිරීමක් කර නැවත ඉදිරිපත් කරන්න.",
    "pendingTitle": "හැඳුනුම් ලේඛන සමාලෝචනයට යටතේ සිටී — පුවරුව නොඇවරා ඇත",
    "pendingBody": "ඔබ ඉදිරිපත් කළ තොරතුරු හා රූප සාර්ථකව ලැබී ඇති අතර පරිපාලන පැනලය මගින් රාජ්‍ය වාර්තාවලට එරෙහිව 24 පැය ඇතුළත සත්‍යාපනය කරනු ලැබේ.",
    "pendingStrong": "ඔබගේ පුවරුව දැනටමත් සම්පූර්ණයෙන්ම අගුලුහරවා ඇති බැවින් සියලු පහසුකම් භාවිතා කළ හැක.",
    "pendingTail": "තොරතුරු පේක්ෂාවක් වැරදි හෝ අසත්‍ය නම් පරිපාලකයාට ගිණුමත් වසා දැමීමට හමුවීමට අයිතියක් ඇත.",
    "unlockTitle": "ඔබගේ පුවරුව සම්පුර්ණයෙන් අගුලුහරවා ගැනීමට පහත පහසුකම් හා හැඳුනුම් ලේඛන ලබාදෙන්න",
    "unlockBody": "පහත තොරතුරු, NID හෝ උපන් සහතිකය, සහ සජීවී මුහුණේ සෙල්ෆි සම්පුර්ණ කොට, සියලු පුවරු විශේෂාංග වහාම අගුලුහරවා ගැනීමට \"Save Profile & Documents\" ක්ලික් කරන්න. පරිපාලකයා ඔබගේ තොරතුරු රාජ්‍ය වාර්තාවලට එරෙහිව සත්‍යාපනය කර අවසන් අනුමතීමට 24 පැය ඇතුළත කටයුතු කරනු ඇත.",
    "verifiedMerchant": "සත්‍යාපිත වෙළෙන්ඳ",
    "underReview": "තහවුරු කිරීම සමාලෝචනය යටතේ (පුවරුව අගුලුහරවා ඇත)",
    "rejected": "තහවුරු කිරීම ප්‍රතික්ෂේප කරන ලදි (ක්‍රියාමාර්ග අවශ්‍යයි)",
    "unverified": "තහවුරු කර නොමැති පැතිකඩ",
    "fullNamePlaceholder": "ඔබේ සම්පූර්ණ නම ඇතුළත් කරන්න",
    "contactNumber": "සම්බන්ධ අංකය",
    "chooseContact": "සම්බන්ධතා ක්‍රමය තෝරන්න:",
    "both": "දෙකම",
    "whatsappPlaceholder": "උදාහරණය: +1... / +44... / +880... (දිස්ත්‍රික් කේතය සමඟ WhatsApp අංකය)",
    "telegramPlaceholder": "උදාහරණය: +1... / +880... හෝ @username (Telegram අංකය හෝ නාමය)",
    "phonePlaceholder": "උදාහරණය: +1... / +44... / +880... (දිස්ත්‍රික් කේතය සමඟ අංකය)",
    "contactNote": "හදිසි දැනුම්දීම් හා සන්නිවේදනය සඳහා තෝරාගත් ක්‍රමයට සක්‍රීය අංකයක් දෙන්න.",
    "identityVerification": "හැඳුනුම් සත්‍යාපනය",
    "birthCertificate": "උපන් සහතිකය",
    "nidCard": "ජාතික හැඳුනුම්පත් (NID කාඩ්)",
    "birthNumber": "උපන් සහතික අංකය (විශේෂ)",
    "birthPlaceholder": "උපන් සහතික අංකය ඇතුළත් කරන්න",
    "nidNumber": "NID අංකය (විශේෂ)",
    "nidPlaceholder": "NID අංකය ඇතුළත් කරන්න",
    "front": "මුහුණ",
    "back": "පසුපස",
    "liveSelfie": "සජීවී මුහුණ සැලසුම් රූපය (පාස්පෝට් වර්ගය)",
    "liveCameraOnly": "සජීවී කැමරා පමණි",
    "selfieInstruction": "කැමරාවට මුහුණ දී පැහැදිලි ආලෝකයේ සජීවී සෙල්ෆි ගන්න.",
    "noSelfie": "සෙල්ෆි නැත",
    "retakeSelfie": "සජීවී සෙල්ෆි නැවත ගන්න",
    "takeSelfie": "සජීවී ඉදිරි කැමරාවෙන් සෙල්ෆි ගන්න",
    "selfieWarning": "වංචාව වැළැක්වීමට, මුහුණ සෙල්ෆිය සජීවී කැමරා පමණක් ගත되어야 합니다 (ගැලරි උඩුගත කිරීම අක්‍රීය).",
    "selfieTip": "ඡායා රූපය ගන්නා විට ඇඳුමක් හෝ මුඛ ආවරණයක් නොදැමීම සහ ප්‍රමාණවත් ආලෝකය තිබීම වළකින්න.",
    "saveUpdating": "ඇදවුම් හා යාවත්කාලීන කරමින්...",
    "updateLinks": "තොරතුරු සහ සමාජ සබැඳි යාවත්කාලීන කරන්න",
    "cameraSuccess": "සජීවී කැමරාවෙන් රූපය සාර්ථකව ගත්තා!",
    "errorPrefix": "පරීක්ෂාව:",
    "criticalWarning": "සංකීර්ණ අනතුරු අඟවීම හා මාර්ගෝපදේශ",
    "rules": [
      "අයදුම්කරුවන් වයස 18 සහ ඒවාකින් ඉහළ නම් NID සහ උපන් සහතිකය දෙකම ලබාදිය යුතුය; උපාන් සහතිකය පමණක් ප්‍රමාණවත් නොවේ.",
      "18ට අඩු වයසැති අයදුම්කරුවන්ට උපන් සහතිකය සහ සජීවී මුහුණ සෙල්ෆි පමණක් ලබාදිය යුතුයි.",
      "උපන් සහතිකය 2010 වර්ෂය හෝ ඊට පෙර උපන් වර්ෂය පෙන්විය යුතුයි.",
      "NID උපන් දිනයෙන් ගණනා කළ වයස 40 වසරට වැඩියක් නොවිය යුතුය; 40ට වැඩි ගිණුම් සත්‍යාපිත නොකෙරේ.",
      "ඉදිරිපත් කළ තොරතුරු සහ සහතික ලේඛන ලබාගත හැකි රාජ්‍ය ඔන්ලයින් වාර්තා සමඟ පරීක්ෂා කෙරේ. වැරදි තොරතුරු, अस्पष्ट හෝ වෙනස් කරන ලද රූප, හෝ නොගැලපෙන දේවල් අනුමත කිරීමට උපරිම නොවේ.",
      "එක NID හෝ උපන් සහතිකය සඳහා පමණක් එක් ගිණුමක් අනුමත කල හැක. පිටපත් ගිණුම් තහනම් වේ."
    ],
    "age18": "18 ඉහළ (18+)",
    "under18": "18ට අඩුව",
    "zoom": "මෙහි විශාල කරන්න",
    "notUploaded": "තවම රූපයක් උඩුගත කර නැත",
    "uploadGallery": "ගොනුව/ගැලරියෙන් උඩුගත කරන්න",
    "uploadDevice": "උපාංගයෙන් රූපය උඩුගත කරන්න"
  },
  "sv": {
    "subtitle": "Hantera din företagsprofil och säkerhetsverifiering",
    "rejectedTitle": "Tidigare verifieringsansökan avslogs",
    "adminNote": "Adminanteckning:",
    "rejectedReason": "Det fanns en inkonsekvens i informationen eller bilderna. Vänligen ta ett tydligt foto med livekameran och skicka in igen.",
    "pendingTitle": "ID-handlingar granskas — instrumentpanelen är upplåst",
    "pendingBody": "Din inskickade information och bilder har tagits emot och kommer att verifieras mot statliga register av adminpanelen inom 24 timmar.",
    "pendingStrong": "Din instrumentpanel har redan blivit helt upplåst så att du kan använda alla funktioner.",
    "pendingTail": "Admin förbehåller sig rätten att blockera ett konto om någon information visar sig vara falsk eller felaktig.",
    "unlockTitle": "Ange nedanstående information och identitetshandlingar för att helt låsa upp din instrumentpanel",
    "unlockBody": "Fyll i informationen nedan, NID eller födelsebevis och en live-selfie, klicka sedan på \"Save Profile & Documents\" för att omedelbart låsa upp alla instrumentpanelsfunktioner. Admin kommer att verifiera din information mot statliga register och ge slutligt godkännande inom 24 timmar.",
    "verifiedMerchant": "Verifierad handlare",
    "underReview": "Verifiering under granskning (instrumentpanelen upplåst)",
    "rejected": "Verifiering avvisad (åtgärd krävs)",
    "unverified": "Overifierad profil",
    "fullNamePlaceholder": "Ange ditt fullständiga namn",
    "contactNumber": "Kontaktnummer",
    "chooseContact": "Välj en kontaktmetod:",
    "both": "Båda",
    "whatsappPlaceholder": "t.ex. +1... / +44... / +880... (WhatsApp-nummer med landskod)",
    "telegramPlaceholder": "t.ex. +1... / +880... eller @username (Telegram-nummer eller användarnamn)",
    "phonePlaceholder": "t.ex. +1... / +44... / +880... (nummer med landskod)",
    "contactNote": "Ange ett aktivt nummer via den valda metoden för brådskande aviseringar och kommunikation.",
    "identityVerification": "Identitetsverifiering",
    "birthCertificate": "Födelsebevis",
    "nidCard": "Nationellt ID (NID-kort)",
    "birthNumber": "Födelsebevisnummer (Unikt)",
    "birthPlaceholder": "Ange födelsebevisnummer",
    "nidNumber": "NID-nummer (Unikt)",
    "nidPlaceholder": "Ange NID-nummer",
    "front": "Framsida",
    "back": "Baksida",
    "liveSelfie": "Live ansiktsselfiefoto (passstorlek)",
    "liveCameraOnly": "Endast livekamera",
    "selfieInstruction": "Vänd ansiktet mot kameran och ta en live-selfie i tydligt ljus.",
    "noSelfie": "Ingen selfie",
    "retakeSelfie": "Ta om live-selfien",
    "takeSelfie": "Ta en selfie med den live frontkameran",
    "selfieWarning": "För att förhindra bedrägeri måste ansiktsselfien tas endast med livekameran (galleriuppladdning inaktiverad).",
    "selfieTip": "Undvik att bära glasögon eller ansiktsmask när du tar fotot och säkerställ tillräcklig belysning.",
    "saveUpdating": "Sparar och uppdaterar...",
    "updateLinks": "Uppdatera information och sociala länkar",
    "cameraSuccess": "Foto fångat framgångsrikt med livekameran!",
    "errorPrefix": "Fel:",
    "criticalWarning": "KRITISK VARNING OCH RIKTLINJER",
    "rules": [
      "Sökande 18 år eller äldre måste lämna både NID och födelsebevis; endast födelsebevis räcker inte.",
      "Sökande under 18 måste endast lämna födelsebevis och live ansiktsselfie.",
      "Födelsebeviset måste visa födelseår 2010 eller tidigare.",
      "Åldern beräknad från NID födelsedatum får inte överstiga 40 år; konton över 40 kommer inte att verifieras.",
      "Inlämnad information och intyg kommer att kontrolleras mot tillgängliga statliga onlineregister. Felaktig information, otydliga eller ändrade bilder eller avvikelser kommer inte att godkännas.",
      "Endast ett konto kan godkännas per NID eller födelsebevis. Dubblettkonton är förbjudna."
    ],
    "age18": "Över 18 (18+)",
    "under18": "Under 18",
    "zoom": "Visa större",
    "notUploaded": "Ingen bild uppladdad än",
    "uploadGallery": "Ladda upp från fil / galleri",
    "uploadDevice": "Ladda upp foto från enhet"
  },
  "da": {
    "subtitle": "Administrer din virksomhedsprofil og sikkerhedsverifikation",
    "rejectedTitle": "Tidligere verifikationsansøgning blev afvist",
    "adminNote": "Admin-note:",
    "rejectedReason": "Der var en uoverensstemmelse i oplysningerne eller billederne. Tag venligst et klart foto med live-kameraet og indsend igen.",
    "pendingTitle": "Identitetsdokumenter er under gennemgang — dashboard låst op",
    "pendingBody": "Dine indsendte oplysninger og billeder blev modtaget og vil blive verificeret mod regeringens registre af adminpanelet inden for 24 timer.",
    "pendingStrong": "Dit dashboard er allerede fuldt låst op, så du kan bruge alle funktioner.",
    "pendingTail": "Admin forbeholder sig retten til at blokere en konto, hvis nogen oplysninger viser sig at være falske eller unøjagtige.",
    "unlockTitle": "Angiv nedenstående oplysninger og identitetsdokumenter for fuldt at låse dit dashboard op",
    "unlockBody": "Udfyld oplysningerne nedenfor, NID eller fødselsattest, og en live ansigtsselfie, klik derefter på \"Save Profile & Documents\" for straks at låse alle dashboard-funktioner op. Admin vil verificere dine oplysninger mod statslige registre og give endelig godkendelse inden for 24 timer.",
    "verifiedMerchant": "Verificeret forhandler",
    "underReview": "Verifikation under vurdering (dashboard låst op)",
    "rejected": "Verifikation afvist (handling nødvendig)",
    "unverified": "Uverificeret profil",
    "fullNamePlaceholder": "Indtast dit fulde navn",
    "contactNumber": "Kontakt nummer",
    "chooseContact": "Vælg en kontaktmetode:",
    "both": "Begge",
    "whatsappPlaceholder": "f.eks. +1... / +44... / +880... (WhatsApp-nummer med landekode)",
    "telegramPlaceholder": "f.eks. +1... / +880... eller @username (Telegram-nummer eller brugernavn)",
    "phonePlaceholder": "f.eks. +1... / +44... / +880... (nummer med landekode)",
    "contactNote": "Angiv et aktivt nummer gennem den valgte metode til hastemeddelelser og kommunikation.",
    "identityVerification": "Identitetsverifikation",
    "birthCertificate": "Fødselsattest",
    "nidCard": "Nationalt ID (NID-kort)",
    "birthNumber": "Fødselsattestnummer (Unikt)",
    "birthPlaceholder": "Indtast fødselsattestnummer",
    "nidNumber": "NID-nummer (Unikt)",
    "nidPlaceholder": "Indtast NID-nummer",
    "front": "Forside",
    "back": "Bagside",
    "liveSelfie": "Live ansigtsselfiefoto (pasfoto størrelse)",
    "liveCameraOnly": "Kun live-kamera",
    "selfieInstruction": "Vend ansigtet mod kameraet og tag en live-selfie i klart lys.",
    "noSelfie": "Ingen selfie",
    "retakeSelfie": "Tag live-selfie igen",
    "takeSelfie": "Tag en selfie med det live frontkamera",
    "selfieWarning": "For at forhindre svindel skal ansigtsselfien tages kun med live-kameraet (galleriupload deaktiveret).",
    "selfieTip": "Undgå at bære briller eller maske, når du tager billedet, og sikr tilstrækkelig belysning.",
    "saveUpdating": "Gemmer og opdaterer...",
    "updateLinks": "Opdater oplysninger og sociale links",
    "cameraSuccess": "Foto optaget med live-kameraet!",
    "errorPrefix": "Fejl:",
    "criticalWarning": "KRITISK ADVARSEL OG RETNINGSLINJER",
    "rules": [
      "Ansøgere på 18 år eller ældre skal fremlægge både NID og fødselsattest; en fødselsattest alene er ikke tilstrækkelig.",
      "Ansøgere under 18 skal kun fremlægge fødselsattest og live ansigtsselfie.",
      "Fødselsattesten skal vise et fødselsår på 2010 eller tidligere.",
      "Alderen beregnet ud fra NID-fødselsdatoen må ikke være mere end 40 år; konti over 40 vil ikke blive verificeret.",
      "Indsendte oplysninger og attester vil blive kontrolleret mod tilgængelige statslige online registre. Forkerte oplysninger, uklare eller ændrede billeder eller uoverensstemmelser vil ikke blive godkendt.",
      "Kun én konto kan godkendes pr. NID eller fødselsattest. Dublerede konti er forbudt."
    ],
    "age18": "Over 18 (18+)",
    "under18": "Under 18",
    "zoom": "Se større",
    "notUploaded": "Intet billede uploadet endnu",
    "uploadGallery": "Upload fra fil / galleri",
    "uploadDevice": "Upload foto fra enhed"
  },
  "hi": {
    "subtitle": "अपने व्यवसाय प्रोफ़ाइल और सुरक्षा सत्यापन प्रबंधित करें",
    "rejectedTitle": "पूर्व सत्यापन आवेदन अस्वीकृत हुआ",
    "adminNote": "प्रशासक नोट:",
    "rejectedReason": "जानकारी या छवियों में असंगति पाई गई। कृपया लाइव कैमरा से स्पष्ट फोटो लें और पुनः प्रस्तुत करें।",
    "pendingTitle": "पहचान दस्तावेज़ समीक्षा में — डैशबोर्ड अनलॉक हुआ",
    "pendingBody": "आपकी प्रस्तुत जानकारी और छवियाँ सफलतापूर्वक प्राप्त हो गईं और 24 घंटे के भीतर प्रशासक पैनल द्वारा सरकारी रिकॉर्ड से मिलान कर सत्यापित की जाएँगी।",
    "pendingStrong": "आपका डैशबोर्ड पहले ही पूरी तरह अनलॉक कर दिया गया है ताकि आप सभी सुविधाओं का उपयोग कर सकें।",
    "pendingTail": "यदि किसी जानकारी में झूठ या अशुद्धि पाई जाती है तो प्रशासक खाते को ब्लॉक करने का अधिकार रखता है।",
    "unlockTitle": "अपने डैशबोर्ड को पूरी तरह अनलॉक करने के लिए नीचे जानकारी और पहचान दस्तावेज़ दें",
    "unlockBody": "नीचे जानकारी, NID या जन्म प्रमाणपत्र तथा लाइव फेस सेल्फी पूरी करें, फिर सभी डैशबोर्ड सुविधाएँ तुरंत अनलॉक करने के लिए \"Save Profile & Documents\" पर क्लिक करें। प्रशासक आपकी जानकारी को सरकारी रिकॉर्ड से मिलाकर 24 घंटे के भीतर अंतिम अनुमोदन देगा।",
    "verifiedMerchant": "सत्यापित व्यापारी",
    "underReview": "सत्यापन समीक्षा में (डैशबोर्ड अनलॉक हुआ)",
    "rejected": "सत्यापन अस्वीकृत (कार्रवाई आवश्यक)",
    "unverified": "असत्यापित प्रोफ़ाइल",
    "fullNamePlaceholder": "अपना पूरा नाम दर्ज करें",
    "contactNumber": "संपर्क नंबर",
    "chooseContact": "संपर्क विधि चुनें:",
    "both": "दोनों",
    "whatsappPlaceholder": "जैसे +1... / +44... / +880... (कंट्री कोड सहित WhatsApp नंबर)",
    "telegramPlaceholder": "जैसे +1... / +880... या @username (Telegram नंबर या उपयोगकर्ता नाम)",
    "phonePlaceholder": "जैसे +1... / +44... / +880... (कंट्री कोड सहित नंबर)",
    "contactNote": "तत्काल सूचनाओं और संचार के लिए चुनी हुई विधि पर सक्रिय नंबर प्रदान करें।",
    "identityVerification": "पहचान सत्यापन",
    "birthCertificate": "जन्म प्रमाणपत्र",
    "nidCard": "राष्ट्रीय पहचान पत्र (NID कार्ड)",
    "birthNumber": "जन्म प्रमाणपत्र संख्या (विशिष्ट)",
    "birthPlaceholder": "जन्म प्रमाणपत्र संख्या दर्ज करें",
    "nidNumber": "NID संख्या (विशिष्ट)",
    "nidPlaceholder": "NID संख्या दर्ज करें",
    "front": "सामने",
    "back": "पीछे",
    "liveSelfie": "लाइव फेस सेल्फी फोटो (पासपोर्ट साइज)",
    "liveCameraOnly": "केवल लाइव कैमरा",
    "selfieInstruction": "कैमरे की ओर देखें और साफ़ रोशनी में लाइव सेल्फी लें।",
    "noSelfie": "कोई सेल्फी नहीं",
    "retakeSelfie": "लाइव सेल्फी फिर से लें",
    "takeSelfie": "लाइव फ्रंट कैमरा से सेल्फी लें",
    "selfieWarning": "धोखाधड़ी रोकने के लिए फेस सेल्फी केवल लाइव कैमरा से ली जानी चाहिए (गैलरी अपलोड अक्षम)।",
    "selfieTip": "फोटो लेते समय चश्मा या मास्क पहनने से बचें और पर्याप्त रोशनी सुनिश्चित करें।",
    "saveUpdating": "सहेजा जा रहा है और अपडेट हो रहा है...",
    "updateLinks": "जानकारी और सोशल लिंक अपडेट करें",
    "cameraSuccess": "लाइव कैमरा से फोटो सफलतापूर्वक कैप्चर हुआ!",
    "errorPrefix": "त्रुटि:",
    "criticalWarning": "गंभीर चेतावनी और दिशानिर्देश",
    "rules": [
      "18 वर्ष और उससे अधिक के आवेदकों को NID और जन्म प्रमाणपत्र दोनों प्रदान करने होंगे; केवल जन्म प्रमाणपत्र पर्याप्त नहीं है।",
      "18 से कम आयु के आवेदकों को केवल जन्म प्रमाणपत्र और लाइव फेस सेल्फी प्रदान करनी होगी।",
      "जन्म प्रमाणपत्र में जन्म वर्ष 2010 या उससे पहले दिखना चाहिए।",
      "NID में दिए जन्म तिथि से गणना की आयु 40 वर्ष से अधिक नहीं होनी चाहिए; 40 से ऊपर के खाते सत्यापित नहीं होंगे।",
      "प्रस्तुत जानकारी और प्रमाणपत्र उपलब्ध सरकारी ऑनलाइन रिकॉर्ड से मिलाकर जाँच किए जाएंगे। गलत जानकारी, अस्पष्ट या बदली हुई छवियाँ, या मिलान न होने पर अनुमोदन नहीं होगा।",
      "प्रति NID या जन्म प्रमाणपत्र केवल एक खाता ही अनुमोदित किया जा सकता है। डुप्लिकेट खाते प्रतिबंधित हैं।"
    ],
    "age18": "18 से ऊपर (18+)",
    "under18": "18 से कम",
    "zoom": "बड़ा देखें",
    "notUploaded": "अभी तक कोई छवि अपलोड नहीं हुई",
    "uploadGallery": "फ़ाइल/गैलरी से अपलोड करें",
    "uploadDevice": "डिवाइस से फोटो अपलोड करें"
  },
  "ar": {
    "subtitle": "إدارة ملف نشاطك والتحقق الأمني",
    "rejectedTitle": "تم رفض طلب التحقق السابق",
    "adminNote": "ملاحظة المشرف:",
    "rejectedReason": "كان هناك تناقض في المعلومات أو الصور. يرجى التقاط صورة واضحة بالكاميرا الحية وإعادة الإرسال.",
    "pendingTitle": "وثائق الهوية قيد المراجعة — لوحة التحكم مفتوحة",
    "pendingBody": "تم استلام معلوماتك والصور المرسلة بنجاح وسيتم التحقق منها مقابل السجلات الحكومية من قبل لوحة الإدارة خلال 24 ساعة.",
    "pendingStrong": "لقد تم بالفعل فتح لوحة التحكم بالكامل حتى تتمكن من استخدام جميع الميزات.",
    "pendingTail": "يحتفظ المشرف بالحق في حظر الحساب إذا تبين أن أي معلومات غير صحيحة أو غير دقيقة.",
    "unlockTitle": "زوّد المعلومات ووثائق الهوية أدناه لفتح لوحة التحكم بالكامل",
    "unlockBody": "أكمل المعلومات أدناه، NID أو شهادة الميلاد، وصورة سيلفي حية، ثم انقر على \"Save Profile & Documents\" لفتح جميع ميزات لوحة التحكم فورًا. سيقوم المشرف بمطابقة معلوماتك مع السجلات الحكومية ومنح الموافقة النهائية خلال 24 ساعة.",
    "verifiedMerchant": "تاجر موثّق",
    "underReview": "التحقق قيد المراجعة (لوحة التحكم مفتوحة)",
    "rejected": "التحقق مرفوض (مطلوب إجراء)",
    "unverified": "ملف غير موثّق",
    "fullNamePlaceholder": "أدخل اسمك الكامل",
    "contactNumber": "رقم الاتصال",
    "chooseContact": "اختر طريقة اتصال:",
    "both": "كلاهما",
    "whatsappPlaceholder": "مثال +1... / +44... / +880... (رقم WhatsApp مع رمز الدولة)",
    "telegramPlaceholder": "مثال +1... / +880... أو @username (رقم Telegram أو اسم المستخدم)",
    "phonePlaceholder": "مثال +1... / +44... / +880... (رقم مع رمز الدولة)",
    "contactNote": "قدّم رقمًا نشطًا عبر الطريقة المختارة للإشعارات العاجلة والتواصل.",
    "identityVerification": "التحقق من الهوية",
    "birthCertificate": "شهادة الميلاد",
    "nidCard": "الهوية الوطنية (بطاقة NID)",
    "birthNumber": "رقم شهادة الميلاد (فريد)",
    "birthPlaceholder": "أدخل رقم شهادة الميلاد",
    "nidNumber": "رقم NID (فريد)",
    "nidPlaceholder": "أدخل رقم NID",
    "front": "الوجه الأمامي",
    "back": "الخلفي",
    "liveSelfie": "صورة سيلفي حية للوجه (مقاس جواز السفر)",
    "liveCameraOnly": "الكاميرا الحية فقط",
    "selfieInstruction": "واجه الكاميرا والتقط سيلفي حي في إضاءة واضحة.",
    "noSelfie": "لا توجد سيلفي",
    "retakeSelfie": "إعادة التقاط السيلفي الحي",
    "takeSelfie": "التقط سيلفي بالكاميرا الأمامية الحية",
    "selfieWarning": "لمنع الاحتيال، يجب التقاط صورة السيلفي بالوجه باستخدام الكاميرا الحية فقط (تحميل من المعرض معطّل).",
    "selfieTip": "تجنب ارتداء النظارات أو القناع أثناء التقاط الصورة وتأكد من إضاءة كافية.",
    "saveUpdating": "جارٍ الحفظ والتحديث...",
    "updateLinks": "تحديث المعلومات والروابط الاجتماعية",
    "cameraSuccess": "تم التقاط الصورة بنجاح باستخدام الكاميرا الحية!",
    "errorPrefix": "خطأ:",
    "criticalWarning": "تحذير وإرشادات حرجة",
    "rules": [
      "يجب على المتقدمين بعمر 18 سنة فأكثر تقديم كل من NID وشهادة الميلاد؛ شهادة الميلاد وحدها غير كافية.",
      "يجب على المتقدمين دون 18 سنة تقديم شهادة الميلاد فقط وصورة سيلفي حية.",
      "يجب أن تُظهر شهادة الميلاد سنة ميلاد 2010 أو قبلها.",
      "يجب أن لا تتجاوز العُمر المحسوب من تاريخ الميلاد في NID أكثر من 40 عامًا؛ لن تُوثّق الحسابات فوق 40.",
      "سيتم فحص المعلومات والشهادات المقدمة مقابل السجلات الحكومية المتاحة عبر الإنترنت. المعلومات غير الصحيحة أو الصور غير الواضحة أو المعدلة أو عدم التطابق لن تُوافق.",
      "يمكن الموافقة على حساب واحد فقط لكل NID أو شهادة ميلاد. الحسابات المكررة ممنوعة."
    ],
    "age18": "فوق 18 (18+)",
    "under18": "تحت 18",
    "zoom": "عرض بحجم أكبر",
    "notUploaded": "لم تُحمّل صورة بعد",
    "uploadGallery": "رفع من ملف / معرض",
    "uploadDevice": "تحميل صورة من الجهاز"
  },
  "fr": {
    "subtitle": "Gérez votre profil commercial et la vérification de sécurité",
    "rejectedTitle": "La demande de vérification précédente a été rejetée",
    "adminNote": "Note de l’administrateur:",
    "rejectedReason": "Il y avait une incohérence dans les informations ou les images. Veuillez prendre une photo claire avec la caméra en direct et soumettre à nouveau.",
    "pendingTitle": "Documents d’identité en cours de vérification — tableau de bord débloqué",
    "pendingBody": "Vos informations et images soumises ont été reçues avec succès et seront vérifiées par le panneau d’administration auprès des registres gouvernementaux sous 24 heures.",
    "pendingStrong": "Votre tableau de bord a déjà été entièrement débloqué afin que vous puissiez utiliser toutes les fonctionnalités.",
    "pendingTail": "L’administrateur se réserve le droit de bloquer un compte si des informations sont fausses ou inexactes.",
    "unlockTitle": "Fournissez les informations et pièces d’identité ci‑dessous pour débloquer entièrement votre tableau de bord",
    "unlockBody": "Complétez les informations ci‑dessous, le NID ou le certificat de naissance, et un selfie facial en direct, puis cliquez sur \"Save Profile & Documents\" pour débloquer immédiatement toutes les fonctionnalités du tableau de bord. L’administrateur vérifiera vos informations auprès des registres gouvernementaux et donnera l’approbation finale sous 24 heures.",
    "verifiedMerchant": "Commerçant vérifié",
    "underReview": "Vérification en cours (Tableau de bord débloqué)",
    "rejected": "Vérification refusée (Action requise)",
    "unverified": "Profil non vérifié",
    "fullNamePlaceholder": "Entrez votre nom complet",
    "contactNumber": "Numéro de contact",
    "chooseContact": "Sélectionnez un mode de contact :",
    "both": "Les deux",
    "whatsappPlaceholder": "ex. +1... / +44... / +880... (numéro WhatsApp avec indicatif pays)",
    "telegramPlaceholder": "ex. +1... / +880... ou @username (numéro Telegram ou nom d’utilisateur)",
    "phonePlaceholder": "ex. +1... / +44... / +880... (numéro avec indicatif pays)",
    "contactNote": "Fournissez un numéro actif via la méthode sélectionnée pour les notifications urgentes et la communication.",
    "identityVerification": "Vérification d’identité",
    "birthCertificate": "Certificat de naissance",
    "nidCard": "Carte d’identité nationale (NID)",
    "birthNumber": "Numéro du certificat de naissance (unique)",
    "birthPlaceholder": "Entrez le numéro du certificat de naissance",
    "nidNumber": "Numéro NID (unique)",
    "nidPlaceholder": "Entrez le numéro NID",
    "front": "Recto",
    "back": "Verso",
    "liveSelfie": "Photo selfie en direct du visage (format passeport)",
    "liveCameraOnly": "Caméra en direct uniquement",
    "selfieInstruction": "Faites face à la caméra et prenez un selfie en direct avec un éclairage clair.",
    "noSelfie": "Pas de selfie",
    "retakeSelfie": "Refaire le selfie en direct",
    "takeSelfie": "Prendre un selfie avec la caméra frontale en direct",
    "selfieWarning": "Pour prévenir la fraude, le selfie doit être pris uniquement avec la caméra en direct (téléversement depuis la galerie désactivé).",
    "selfieTip": "Évitez de porter des lunettes ou un masque lors de la prise de la photo et assurez‑vous d’un éclairage suffisant.",
    "saveUpdating": "Enregistrement et mise à jour...",
    "updateLinks": "Mettre à jour les informations et les liens sociaux",
    "cameraSuccess": "Photo capturée avec succès avec la caméra en direct !",
    "errorPrefix": "Erreur :",
    "criticalWarning": "AVERTISSEMENT CRITIQUE ET DIRECTIVES",
    "rules": [
      "Les candidats âgés de 18 ans ou plus doivent fournir à la fois le NID et le certificat de naissance ; un certificat de naissance seul n’est pas suffisant.",
      "Les candidats de moins de 18 ans doivent fournir uniquement un certificat de naissance et un selfie facial en direct.",
      "Le certificat de naissance doit indiquer une année de naissance de 2010 ou antérieure.",
      "L’âge calculé à partir de la date de naissance du NID ne doit pas dépasser 40 ans ; les comptes de plus de 40 ans ne seront pas vérifiés.",
      "Les informations et certificats soumis seront vérifiés par rapport aux registres gouvernementaux en ligne disponibles. Les informations incorrectes, les images floues ou modifiées, ou les discordances ne seront pas approuvées.",
      "Un seul compte peut être approuvé par NID ou certificat de naissance. Les comptes en double sont interdits."
    ],
    "age18": "Plus de 18 (18+)",
    "under18": "Moins de 18",
    "zoom": "Voir en plus grand",
    "notUploaded": "Aucune image téléchargée pour le moment",
    "uploadGallery": "Téléverser depuis fichier / galerie",
    "uploadDevice": "Téléverser une photo depuis l’appareil"
  },
  "es": {
    "subtitle": "Gestiona tu perfil comercial y la verificación de seguridad",
    "rejectedTitle": "La solicitud de verificación anterior fue rechazada",
    "adminNote": "Nota del administrador:",
    "rejectedReason": "Hubo una inconsistencia en la información o las imágenes. Por favor toma una foto clara con la cámara en vivo y vuelve a enviar.",
    "pendingTitle": "Documentos de identidad en revisión — panel desbloqueado",
    "pendingBody": "La información y las imágenes que enviaste se recibieron correctamente y serán verificadas contra los registros gubernamentales por el panel de administración en un plazo de 24 horas.",
    "pendingStrong": "Tu panel ya ha sido totalmente desbloqueado para que puedas usar todas las funciones.",
    "pendingTail": "El administrador se reserva el derecho de bloquear una cuenta si se detecta que alguna información es falsa o inexacta.",
    "unlockTitle": "Proporciona la información y los documentos de identidad a continuación para desbloquear completamente tu panel",
    "unlockBody": "Completa la información a continuación, NID o acta de nacimiento, y la selfie en vivo, luego haz clic en \"Save Profile & Documents\" para desbloquear todas las funciones del panel de inmediato. El administrador verificará tu información con los registros gubernamentales y dará la aprobación final en un plazo de 24 horas.",
    "verifiedMerchant": "Comerciante verificado",
    "underReview": "Verificación en revisión (Panel desbloqueado)",
    "rejected": "Verificación rechazada (Se requiere acción)",
    "unverified": "Perfil no verificado",
    "fullNamePlaceholder": "Ingresa tu nombre completo",
    "contactNumber": "Número de contacto",
    "chooseContact": "Selecciona un método de contacto:",
    "both": "Ambos",
    "whatsappPlaceholder": "p. ej. +1... / +44... / +880... (número de WhatsApp con código de país)",
    "telegramPlaceholder": "p. ej. +1... / +880... o @usuario (número o usuario de Telegram)",
    "phonePlaceholder": "p. ej. +1... / +44... / +880... (número con código de país)",
    "contactNote": "Proporciona un número activo por el método seleccionado para notificaciones urgentes y comunicación.",
    "identityVerification": "Verificación de identidad",
    "birthCertificate": "Acta de nacimiento",
    "nidCard": "Documento Nacional de Identidad (NID)",
    "birthNumber": "Número de acta de nacimiento (Único)",
    "birthPlaceholder": "Ingresa el número del acta de nacimiento",
    "nidNumber": "Número NID (Único)",
    "nidPlaceholder": "Ingresa el número NID",
    "front": "Frente",
    "back": "Reverso",
    "liveSelfie": "Selfie en vivo (tamaño pasaporte)",
    "liveCameraOnly": "Solo cámara en vivo",
    "selfieInstruction": "Mira a la cámara y toma una selfie en vivo con buena iluminación.",
    "noSelfie": "Sin selfie",
    "retakeSelfie": "Volver a tomar selfie en vivo",
    "takeSelfie": "Tomar selfie con la cámara frontal en vivo",
    "selfieWarning": "Para evitar fraudes, la selfie debe tomarse solo con la cámara en vivo (subida desde galería deshabilitada).",
    "selfieTip": "Evita usar gafas o mascarilla y asegúrate de tener iluminación suficiente.",
    "saveUpdating": "Guardando y actualizando...",
    "updateLinks": "Actualizar información y enlaces sociales",
    "cameraSuccess": "¡Foto tomada con éxito con la cámara en vivo!",
    "errorPrefix": "Error:",
    "criticalWarning": "ADVERTENCIA CRÍTICA Y DIRECTRICES",
    "rules": [
      "Los solicitantes de 18 años o más deben proporcionar tanto NID como acta de nacimiento; solo el acta de nacimiento no es suficiente.",
      "Los solicitantes menores de 18 deben proporcionar únicamente el acta de nacimiento y una selfie en vivo.",
      "El acta de nacimiento debe mostrar un año de nacimiento de 2010 o anterior.",
      "La edad calculada a partir de la fecha de nacimiento en el NID no debe ser mayor de 40 años; las cuentas de más de 40 no serán verificadas.",
      "La información y los certificados enviados serán comprobados contra los registros gubernamentales en línea disponibles. Información incorrecta, imágenes poco claras o alteradas, o discrepancias no serán aprobadas.",
      "Solo se puede aprobar una cuenta por NID o acta de nacimiento. Las cuentas duplicadas están prohibidas."
    ],
    "age18": "Mayor de 18 (18+)",
    "under18": "Menor de 18",
    "zoom": "Ver más grande",
    "notUploaded": "Aún no se ha subido imagen",
    "uploadGallery": "Subir desde archivo / galería",
    "uploadDevice": "Subir foto desde el dispositivo"
  },
  "pt": {
    "subtitle": "Gerencie seu perfil comercial e a verificação de segurança",
    "rejectedTitle": "A solicitação de verificação anterior foi rejeitada",
    "adminNote": "Nota do administrador:",
    "rejectedReason": "Houve inconsistência nas informações ou imagens. Por favor, tire uma foto nítida com a câmera ao vivo e envie novamente.",
    "pendingTitle": "Documentos de identidade em análise — painel desbloqueado",
    "pendingBody": "As informações e imagens que você enviou foram recebidas com sucesso e serão verificadas com os registros governamentais pela equipe administrativa dentro de 24 horas.",
    "pendingStrong": "Seu painel já foi totalmente desbloqueado para que você possa usar todos os recursos.",
    "pendingTail": "O administrador reserva-se o direito de bloquear uma conta caso qualquer informação seja falsa ou imprecisa.",
    "unlockTitle": "Forneça as informações e documentos de identidade abaixo para desbloquear totalmente seu painel",
    "unlockBody": "Complete as informações abaixo, NID ou certidão de nascimento, e uma selfie ao vivo, então clique em \"Save Profile & Documents\" para desbloquear todos os recursos do painel imediatamente. O administrador verificará suas informações com os registros governamentais e dará a aprovação final em até 24 horas.",
    "verifiedMerchant": "Comerciante verificado",
    "underReview": "Verificação em análise (Painel desbloqueado)",
    "rejected": "Verificação rejeitada (Ação necessária)",
    "unverified": "Perfil não verificado",
    "fullNamePlaceholder": "Insira seu nome completo",
    "contactNumber": "Número de contato",
    "chooseContact": "Selecione um método de contato:",
    "both": "Ambos",
    "whatsappPlaceholder": "ex.: +1... / +44... / +880... (número do WhatsApp com código do país)",
    "telegramPlaceholder": "ex.: +1... / +880... ou @usuario (número ou usuário do Telegram)",
    "phonePlaceholder": "ex.: +1... / +44... / +880... (número com código do país)",
    "contactNote": "Forneça um número ativo através do método selecionado para notificações urgentes e comunicação.",
    "identityVerification": "Verificação de identidade",
    "birthCertificate": "Certidão de nascimento",
    "nidCard": "Documento Nacional de Identidade (NID)",
    "birthNumber": "Número da certidão de nascimento (Único)",
    "birthPlaceholder": "Insira o número da certidão de nascimento",
    "nidNumber": "Número NID (Único)",
    "nidPlaceholder": "Insira o número NID",
    "front": "Frente",
    "back": "Verso",
    "liveSelfie": "Selfie facial ao vivo (tamanho passaporte)",
    "liveCameraOnly": "Apenas câmera ao vivo",
    "selfieInstruction": "Encare a câmera e tire uma selfie ao vivo com iluminação clara.",
    "noSelfie": "Sem selfie",
    "retakeSelfie": "Refazer selfie ao vivo",
    "takeSelfie": "Tirar selfie com a câmera frontal ao vivo",
    "selfieWarning": "Para evitar fraude, a selfie deve ser tirada apenas com a câmera ao vivo (upload da galeria desabilitado).",
    "selfieTip": "Evite usar óculos ou máscara ao tirar a foto e garanta iluminação suficiente.",
    "saveUpdating": "Salvando e atualizando...",
    "updateLinks": "Atualizar informações e links sociais",
    "cameraSuccess": "Foto capturada com sucesso pela câmera ao vivo!",
    "errorPrefix": "Erro:",
    "criticalWarning": "AVISO CRÍTICO E DIRETRIZES",
    "rules": [
      "Candidatos com 18 anos ou mais devem fornecer tanto o NID quanto a certidão de nascimento; apenas a certidão não é suficiente.",
      "Candidatos menores de 18 devem fornecer apenas a certidão de nascimento e uma selfie ao vivo.",
      "A certidão de nascimento deve mostrar ano de nascimento de 2010 ou anterior.",
      "A idade calculada a partir da data de nascimento no NID não deve ser superior a 40 anos; contas acima de 40 não serão verificadas.",
      "As informações e certificados enviados serão checados contra registros governamentais online disponíveis. Informações incorretas, imagens pouco claras ou alteradas, ou divergências não serão aprovadas.",
      "Apenas uma conta pode ser aprovada por NID ou certidão de nascimento. Contas duplicadas são proibidas."
    ],
    "age18": "Acima de 18 (18+)",
    "under18": "Menor de 18",
    "zoom": "Ver em tamanho maior",
    "notUploaded": "Nenhuma imagem enviada ainda",
    "uploadGallery": "Enviar do arquivo / galeria",
    "uploadDevice": "Enviar foto do dispositivo"
  }
} as const;
